"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    article: 'Artikel' || 'article',
    setOwningSupplierOrganization: 'Ändra ägare av artikel' || 'setOwningSupplierOrganization',
    handlePublications: 'Hantera publicering' || 'handlePublications',
    publishOnExacta: 'Förbered för systembolaget' || 'publishOnExacta',
    deactivate: 'Inaktivera artikel' || 'deactivate',
    activate: 'Aktivera artikel' || 'activate',
    markAsOutOfStock: 'Markera som tillfälligt slut' || 'markAsOutOfStock',
    markAsInStock: 'Markera som tillgänglig för försäljning' || 'markAsInStock',
    startCampaign: 'Starta priskampanj' || 'startCampaign',
    endCampaign: 'Avsluta priskampanj' || 'endCampaign',
    setSupplierArticleNumber: 'Sätt leverantörsartikelnummer' || 'setSupplierArticleNumber',
    testGuardedActionCall: 'testGuardedActionCall' || 'testGuardedActionCall',
    setVindenStockQuantity: 'setVindenStockQuantity' || 'setVindenStockQuantity',
    setBatchQuantity: 'SetBatchQuantity' || 'setBatchQuantity',
    updateStockQuantities: 'SetStockQuantities' || 'updateStockQuantities',
    updateExactaStockQuantities: 'updateExactaStockQuantities' || 'updateExactaStockQuantities',
    ensureInvariants: 'Räkna om totaler' || 'ensureInvariants',
    blockBatch: 'Blockera parti' || 'blockBatch',
    unblockBatch: 'Avblockera parti' || 'unblockBatch',
    blockBatchesOnOrderFullfillmentCenter: 'Blockera samtliga partier på lagerställe' ||
        'blockBatchesOnOrderFullfillmentCenter',
    unblockBatchesOnOrderFullfillmentCenter: 'Avblockera samtliga partier på lagerställe' ||
        'unblockBatchesOnOrderFullfillmentCenter',
    blockAllBatches: 'Blockera alla partier' || 'blockAllBatches',
    unblockAllBatches: 'Avblockera alla partier' || 'unblockAllBatches',
    updateFromExternalSource: '' || 'updateFromExternalSource',
    writeArticle: 'Spara artikel' || 'writeArticle',
    importArticle: 'Importera artikel' || 'importArticle',
    addFlaivyImages: 'Lägg till bilder' || 'addFlaivyImages',
    updateStockKeepingUnits: 'Uppdatera enheter' || 'updateStockKeepingUnits',
    fortnoxArticle: 'Skapa artikel från Fortnox' || 'fortnoxArticle',
    editArticleBatches: 'Redigera partier' || 'editArticleBatches',
    updateStockQuantitiesManually: 'Uppdatera lagersaldon manuellt' || 'updateStockQuantitiesManually',
    privabImportArticle: 'Importera artiklar' || 'privabImportArticle',
    ensureArticleBatchesForOfc: 'Sätt lagersaldo för lagerställe' || 'ensureArticleBatchesForOfc',
    addLabel: 'Lägg till etikett' || 'addLabel',
    removeLabel: 'Ta bort etikett' || 'removeLabel',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    articleNumber: 'Artikelnummer' || 'articleNumber',
    supplierArticleNumber: 'Tillverkarens artikelnummer' || 'supplierArticleNumber',
    productCategory: 'Kategori / Typ / Stil' || 'productCategory',
    organizationProductCategory: 'Organisationens produktkategori' || 'organizationProductCategory',
    varuTypDimensionCode: 'Dimensionskod för varutyp' || 'varuTypDimensionCode',
    varuTypDimensionCodes: {
        0: '0 - Konfektyrer' || '0',
        '0050': '0050 - 100G CHOKLADKAKA EXPODISPLAY' || '0050',
        '0051': '0051 - 100G CHOKLADKAKA PREMIUM' || '0051',
        '0052': '0052 - 100G CHOKLADKAKOR' || '0052',
        '0053': '0053 - 100G CHOKLADKAKOR PREMIUM EXPODISPLAY' || '0053',
        '0054': '0054 - 150G &gt; CHOKLADKAKOR PREMIUM' || '0054',
        '0055': '0055 - 150G &gt; CHOKLADKAKOR PREMIUM EXPODISPLAY' || '0055',
        '0056': '0056 - 200G &gt; CHOKLADKAKOR' || '0056',
        '0057': '0057 - 200G &gt; CHOKLADKAKOR EXPODISPLAY' || '0057',
        '0058': '0058 - DUBBLA &amp; STORA STYCKSAKER' || '0058',
        '0059': '0059 - DUBBLA &amp; STORA STYCKSAKER EXPODISPLAY' || '0059',
        '0060': '0060 - ENKLA STYCKSAKER. CHOKLAD' || '0060',
        '0061': '0061 - ENKLA STYCKSAKER. CHOKLAD EXPODISPLAY' || '0061',
        '0062': '0062 - ENKLA STYCKSAKER. SOCKERKONFEKTYR' || '0062',
        '0063': '0063 - ENKLA STYCKSAKER. SOCKERKONFEKTYR EXPODI' || '0063',
        '0064': '0064 - PÅSAR' || '0064',
        '0065': '0065 - PÅSAR. KONFEKTYR EXPODISPLAY' || '0065',
        '0066': '0066 - RULLAR EXPODISPLAY' || '0066',
        '0067': '0067 - RULLAR. CHOKLAD' || '0067',
        '0068': '0068 - RULLAR. SOCKERKONFEKTYR' || '0068',
        '0069': '0069 - SOCKERVADD' || '0069',
        '0070': '0070 - HÄLSOBARS' || '0070',
        '0071': '0071 - KONFEKTYR TRAVEL RETAIL' || '0071',
        '0072': '0072 - Lösvikt Inslaget' || '0072',
        '0073': '0073 - Lösvikt Oinslaget' || '0073',
        '0076': '0076 - MARSHMALLOWS' || '0076',
        '0077': '0077 - NATURGODIS LÖSVIKT' || '0077',
        '0078': '0078 - PRALINER' || '0078',
        '0079': '0079 - PRESENT/KONFEKTYRASK' || '0079',
        '0080': '0080 - PRESENT/KONFEKTYRASK EXPODISPLAY' || '0080',
        '0081': '0081 - PRESENTASK' || '0081',
        '0082': '0082 - STJÄRNVINST/TIVOLIVINST' || '0082',
        '0083': '0083 - UPPFRÄSCHARE HALLSTABLETT. PÅSAR EXPODIS' || '0083',
        '0084': '0084 - UPPFRÄSCHARE HALLSTABLETT/HYLLARTIKEL EX' || '0084',
        '0085': '0085 - UPPFRÄSCHARE HALLSTABLETTASK/HYLLARTIKEL' || '0085',
        '0086': '0086 - UPPFRÄSCHARE TUGGUMMI BURK' || '0086',
        '0087': '0087 - UPPFRÄSCHARE TUGGUMMI EXPODISPLAY' || '0087',
        '0088': '0088 - UPPFRÄSCHARE TUGGUMMI HYLLARTIKEL' || '0088',
        '0089': '0089 - UPPFRÄSCHARE TUGGUMMI PÅSAR' || '0089',
        '0090': '0090 - UPPFRÄSCHARE TUGGUMMI PÅSAR EXPODISPLAY' || '0090',
        '0091': '0091 - UPPFRÄSHARE HALLSTABLETT. PÅSAR' || '0091',
        '0095': '0095 - BARNGODIS BARNASKAR' || '0095',
        '0096': '0096 - BARNGODIS BARNASKAR EXPODISPLAY' || '0096',
        '0097': '0097 - BARNGODIS BARNSTYCKSAKER' || '0097',
        '0098': '0098 - BARNGODIS BARNSTYCKSAKER EXPODISPLAY' || '0098',
        '0099': '0099 - BARNGODIS KLUBBA' || '0099',
        '0101': '0101 - SÄSONGSVARA JUL' || '0101',
        '0102': '0102 - SÄSONGSVARA PÅSK' || '0102',
        '0105': '0105 - BARNGODIS KLUBBA' || '0105',
        '0109': '0109 - BENÄMNING SAKNAS' || '0109',
        '0110': '0110 - CHIPS 150G' || '0110',
        '0117': '0117 - CHIPS 300G' || '0117',
        '0147': '0147 - Okänd' || '0147',
        '0177': '0177 - NATURGODIS LÖSVIKT' || '0177',
        '0206': '0206 - LÄSK RETURGLAS 33CL' || '0206',
        '0217': '0217 - ' || '0217',
        '0245': '0245 - ' || '0245',
        '0300': '0300 - CHOKLADKAKOR' || '0300',
        '0302': '0302 - KEXCHOKLAD' || '0302',
        '0306': '0306 - ENKLA STYCKSAKER' || '0306',
        '0307': '0307 - DUBBLA STYCKSAKER' || '0307',
        '0308': '0308 - PRESENTASKAR &lt; 500G' || '0308',
        '0310': '0310 - PRESENTASKAR &gt; 500G' || '0310',
        '0326': '0326 - PÅSAR KONFEKTYR CHOKLAD' || '0326',
        '0328': '0328 - KONFEKTYR I BURK' || '0328',
        '0342': '0342 - TUGGUMMI S-FRITT' || '0342',
        '0344': '0344 - TUGGUMMI BARN' || '0344',
        '0345': '0345 - GODIS MED LEKVÄRDE' || '0345',
        '0350': '0350 - HALSTABLETT' || '0350',
        '0352': '0352 - HALSTABLETT S-FRITT' || '0352',
        '0358': '0358 - EXPO DISPLAY UPPFRÄSCHARE' || '0358',
        '0360': '0360 - STYCKSAK KONF OINSLAGEN' || '0360',
        '0362': '0362 - STYCKSAK KONF INSLAGEN' || '0362',
        '0364': '0364 - RULLAR KONFEKTYR' || '0364',
        '0366': '0366 - OINSLAGET/LÖSVIKT/PLOCK' || '0366',
        '0368': '0368 - INSLAGET/LÖSVIKT/PLOCK' || '0368',
        '0376': '0376 - Klubbor' || '0376',
        '0384': '0384 - UPPFRÄSCHARE HALLSTABLETT/HYLLARTIKEL EX' || '0384',
        '0392': '0392 - ENERGIPRODUKTER' || '0392',
        '0395': '0395 - EXPO DISPLAY PALLAR ETC' || '0395',
        '0397': '0397 - SÄSONGSVARA JUL' || '0397',
        '0414': '0414 - SALTA PINNAR' || '0414',
        '0493': '0493 - ' || '0493',
        '0575': '0575 - KAFFEKEX KAKOR' || '0575',
        '0592': '0592 - KRYDDOR GLAS' || '0592',
        '0667': '0667 - KAKFYLLNING BAKMASSOR' || '0667',
        '0670': '0670 - KAKFYLLNING BAKMASSOR' || '0670',
        '0700': '0700 - OST MJUK' || '0700',
        '0760': '0760 - ENKLA STYCKSAKER. CHOKLAD' || '0760',
        '0764': '0764 - PÅSAR' || '0764',
        '0770': '0770 - ' || '0770',
        '0772': '0772 - LÖSVIKT' || '0772',
        '0773': '0773 - ' || '0773',
        '0777': '0777 - ' || '0777',
        '0779': '0779 - PRESENT/KONFEKTYRASK' || '0779',
        '0789': '0789 - UPPFRÄSCHARE TUGGUMMI PÅSAR' || '0789',
        '0790': '0790 - UPPFRÄSCHARE TUGGUMMI PÅSAR EXPODISPLAY' || '0790',
        '0889': '0889 - FAST FOOD FÄRSK' || '0889',
        '0941': '0941 - ENGÅNGSARTIKLAR' || '0941',
        '0996': '0996 - Ospec låg moms' || '0996',
        '0997': '0997 - Ospec hög moms' || '0997',
        '0999': '0999 - PANT' || '0999',
        1: '1 - Snacks' || '1',
        1064: '1064 - PÅSAR' || '1064',
        1101: '1101 - SÄSONGSVARA JUL' || '1101',
        1109: '1109 - BENÄMNING SAKNAS' || '1109',
        1110: '1110 - CHIPS 150G' || '1110',
        1111: '1111 - CHIPS 165G' || '1111',
        1112: '1112 - CHIPS 175G' || '1112',
        1113: '1113 - CHIPS 190G' || '1113',
        1114: '1114 - CHIPS 200G' || '1114',
        1115: '1115 - CHIPS 27.5G-40G' || '1115',
        1116: '1116 - CHIPS 275G' || '1116',
        1117: '1117 - CHIPS 300G' || '1117',
        1118: '1118 - CHIPS 370G' || '1118',
        1119: '1119 - CHIPS 450G' || '1119',
        1120: '1120 - CHIPS EXPODISPLAY' || '1120',
        1121: '1121 - DIPP' || '1121',
        1122: '1122 - DIPP EXPODISPLAY' || '1122',
        1123: '1123 - EXTRUDERAT 100G' || '1123',
        1124: '1124 - EXTRUDERAT 120G' || '1124',
        1125: '1125 - EXTRUDERAT 125G' || '1125',
        1126: '1126 - EXTRUDERAT 150G' || '1126',
        1128: '1128 - EXTRUDERAT 165G' || '1128',
        1129: '1129 - EXTRUDERAT 170G' || '1129',
        1130: '1130 - EXTRUDERAT 175G' || '1130',
        1131: '1131 - EXTRUDERAT 180G' || '1131',
        1132: '1132 - EXTRUDERAT 198.5G' || '1132',
        1133: '1133 - EXTRUDERAT 220G' || '1133',
        1134: '1134 - EXTRUDERAT 225G' || '1134',
        1135: '1135 - EXTRUDERAT 250G' || '1135',
        1136: '1136 - EXTRUDERAT 28.4G' || '1136',
        1137: '1137 - EXTRUDERAT 35G' || '1137',
        1138: '1138 - EXTRUDERAT 450G' || '1138',
        1139: '1139 - EXTRUDERAT 75G' || '1139',
        1140: '1140 - EXTRUDERAT ÖVRIGT' || '1140',
        1141: '1141 - HÄLSOSNACKS' || '1141',
        1142: '1142 - MELLANMÅL PRODUKTER' || '1142',
        1144: '1144 - NÖTTER  150-200G' || '1144',
        1145: '1145 - NÖTTER 1000-1300G' || '1145',
        1146: '1146 - NÖTTER 200-300G' || '1146',
        1147: '1147 - NÖTTER 300-500G' || '1147',
        1148: '1148 - NÖTTER 40-85G' || '1148',
        1149: '1149 - NÖTTER 7000G' || '1149',
        1150: '1150 - NÖTTER 70-85G EXPODISPLAY' || '1150',
        1151: '1151 - NÖTTER EXPODISPLAY' || '1151',
        1152: '1152 - POPCORN' || '1152',
        1153: '1153 - PREMIUM CHIPS  40-90G' || '1153',
        1154: '1154 - PREMIUM CHIPS 140-200G' || '1154',
        1155: '1155 - SALTA PINNAR' || '1155',
        1159: '1159 - BENÄMNING SAKNAS' || '1159',
        1170: '1170 - HÄLSOBARS' || '1170',
        1172: '1172 - LÖSVIKT' || '1172',
        1326: '1326 - Okänd' || '1326',
        1392: '1392 - Energiprodukter' || '1392',
        1393: '1393 - NATURGODIS' || '1393',
        1400: '1400 - CHIPS' || '1400',
        1402: '1402 - EXTRUDERAT(TYP OSTBÅGAR O.S.V.)' || '1402',
        1404: '1404 - NÖTTER' || '1404',
        1406: '1406 - POPCORN' || '1406',
        1410: '1410 - POPCORN MICRO' || '1410',
        1414: '1414 - SALTA PINNAR' || '1414',
        1421: '1421 - EXPO DISPLAY SNACKS' || '1421',
        1493: '1493 - ENERGIDRYCK' || '1493',
        1667: '1667 - KAKFYLLNING BAKMASSOR' || '1667',
        1678: '1678 - TACO MED TILLBEHÖR' || '1678',
        1996: '1996 - Ospec låg moms' || '1996',
        2: '2 - Drycker' || '2',
        2101: '2101 - SÄSONGSVARA JUL' || '2101',
        2102: '2102 - SÄSONGSVARA PÅSK' || '2102',
        2142: '2142 - MELLANMÅL PRODUKTER' || '2142',
        2160: '2160 - CIDER BURK 33CL' || '2160',
        2161: '2161 - CIDER GLASFLASKA 25CL' || '2161',
        2162: '2162 - CIDER PET 1.5L' || '2162',
        2163: '2163 - CIDER PET 1L' || '2163',
        2164: '2164 - CIDER PET 50CL' || '2164',
        2165: '2165 - ENERGIDRYCK BURK 25CL' || '2165',
        2166: '2166 - ENERGIDRYCK BURK 25CL EXPODISPLAY' || '2166',
        2167: '2167 - ENERGIDRYCK BURK 33CL' || '2167',
        2168: '2168 - ENERGIDRYCK BURK 35.5CL' || '2168',
        2169: '2169 - ENERGIDRYCK BURK 47.3CL' || '2169',
        2170: '2170 - ENERGIDRYCK BURK 50CL' || '2170',
        2171: '2171 - ENERGIDRYCK GLASFLASKA 25CL' || '2171',
        2173: '2173 - ENERGIDRYCK PET 1L' || '2173',
        2174: '2174 - ENERGIDRYCK PET 33CL' || '2174',
        2175: '2175 - ' || '2175',
        2176: '2176 - ENERGIDRYCK PET 50CL' || '2176',
        2177: '2177 - FUNKTIONELL/HÄLSODRYCK BURK 25CL' || '2177',
        2178: '2178 - FUNKTIONELL/HÄLSODRYCK BURK 33CL' || '2178',
        2179: '2179 - FUNKTIONELL/HÄLSODRYCK EXPODISPLAY' || '2179',
        2180: '2180 - FUNKTIONELL/HÄLSODRYCK PET 35CL' || '2180',
        2181: '2181 - FUNKTIONELL/HÄLSODRYCK PET 50CL' || '2181',
        2182: '2182 - FUNKTIONELL/HÄLSODRYCK PET 60CL' || '2182',
        2183: '2183 - JUICE DRICKFÄRDIG' || '2183',
        2184: '2184 - JUICE DRICKFÄRDIG EXPODISPLAY' || '2184',
        2185: '2185 - KAFFE/TE/CHOKLADDRYCK' || '2185',
        2186: '2186 - KONCENTRAT' || '2186',
        2188: '2188 - LÄSK BURK 15CL' || '2188',
        2189: '2189 - LÄSK BURK 25CL' || '2189',
        2190: '2190 - LÄSK BURK 33CL' || '2190',
        2191: '2191 - LÄSK BURK 35.5CL' || '2191',
        2192: '2192 - LÄSK BURK 44.8CL' || '2192',
        2193: '2193 - LÄSK GLAS 30CL' || '2193',
        2194: '2194 - LÄSK GLASSFLASKA 35.5CL' || '2194',
        2195: '2195 - LÄSK PET 1.5L' || '2195',
        2196: '2196 - LÄSK PET 1.5L EXPODISPLAY' || '2196',
        2198: '2198 - LÄSK PET 1L' || '2198',
        2199: '2199 - LÄSK PET 2L' || '2199',
        2200: '2200 - LÄSK PET 2L EXPODISPLAY' || '2200',
        2201: '2201 - LÄSK PET 33CL' || '2201',
        2202: '2202 - LÄSK PET 50CL' || '2202',
        2203: '2203 - LÄSK PET 50CL EXPODISPLAY' || '2203',
        2204: '2204 - LÄSK RETURGLAS 25CL' || '2204',
        2206: '2206 - LÄSK RETURGLAS 33CL' || '2206',
        2208: '2208 - Okänd' || '2208',
        2210: '2210 - SMOOTHIE' || '2210',
        2211: '2211 - STILLDRINK  27.5 CL' || '2211',
        2212: '2212 - STILLDRINK  47.3 CL' || '2212',
        2213: '2213 - STILLDRINK  BURK 34CL' || '2213',
        2214: '2214 - STILLDRINK 20CL' || '2214',
        2215: '2215 - STILLDRINK 25CL' || '2215',
        2216: '2216 - STILLDRINK 50 CL PET' || '2216',
        2217: '2217 - STILLDRINK BURK 33CL' || '2217',
        2218: '2218 - STILLDRINK EXPODISPLAY' || '2218',
        2219: '2219 - STILLDRINK PET 33CL' || '2219',
        2220: '2220 - STILLDRINK TETRA 20CL' || '2220',
        2221: '2221 - Okänd' || '2221',
        2222: '2222 - STILLDRINK TETRA 25CL' || '2222',
        2223: '2223 - STILLDRINK TETRA 33CL' || '2223',
        2224: '2224 - SÄSONG JUL' || '2224',
        2225: '2225 - TE' || '2225',
        2226: '2226 - VATTEN BURK 33CL' || '2226',
        2227: '2227 - VATTEN EXPODISPLAY' || '2227',
        2228: '2228 - VATTEN GLASFLASKA 33CL' || '2228',
        2229: '2229 - VATTEN PET 1.5L' || '2229',
        2230: '2230 - VATTEN PET 1.5L EXPODISPLAY' || '2230',
        2231: '2231 - VATTEN PET 33CL' || '2231',
        2232: '2232 - VATTEN PET 50CL' || '2232',
        2233: '2233 - VATTEN PET 50CL EXPODISPLAY' || '2233',
        2234: '2234 - VATTEN PET 65CL' || '2234',
        2235: '2235 - VATTEN PET 75CL' || '2235',
        2236: '2236 - VATTEN RETURGLAS 33CL' || '2236',
        2237: '2237 - ÖL KLASS 1 BURK 33CL' || '2237',
        2238: '2238 - ÖL KLASS 1/ ALKOFRI BURK' || '2238',
        2239: '2239 - ÖL KLASS 1/ ALKOFRI GLASFLASKA' || '2239',
        2240: '2240 - ÖL KLASS 2 BURK 50CL' || '2240',
        2241: '2241 - ÖL KLASS 3  BURK EXPODISPLAY' || '2241',
        2242: '2242 - ÖL KLASS 3 BURK' || '2242',
        2243: '2243 - ÖL KLASS 3 GLASFLASKA' || '2243',
        2244: '2244 - ÖL KLASS1/ ALKOFRI' || '2244',
        2245: '2245 - ÅTERHÄMTNING/PROTEINDRYCK' || '2245',
        2249: '2249 - ÖVRIGA DRYCKER' || '2249',
        2260: '2260 - Okänd' || '2260',
        2261: '2261 - Okänd' || '2261',
        2292: '2292 - Okänd' || '2292',
        2294: '2294 - Okänd' || '2294',
        2308: '2308 - Okänd' || '2308',
        2326: '2326 - Okänd' || '2326',
        2397: '2397 - Säsongsvara Jul' || '2397',
        2400: '2400 - Okänd' || '2400',
        2450: '2450 - ÖL KLASS I' || '2450',
        2460: '2460 - ÖL KLASS II' || '2460',
        2472: '2472 - LÄSK RETURBURK' || '2472',
        2474: '2474 - LÄSK RETUR PET' || '2474',
        2475: '2475 - LÄSK RETURGLAS' || '2475',
        2482: '2482 - Vatten Returburk' || '2482',
        2484: '2484 - VATTEN RETUR PET' || '2484',
        2490: '2490 - STILLDRINK' || '2490',
        2492: '2492 - CIDER' || '2492',
        2493: '2493 - ENERGIDRYCK' || '2493',
        2494: '2494 - ÖVRIGA DRYCKER' || '2494',
        2495: '2495 - Choklad kaffedrycker' || '2495',
        2499: '2499 - EXPO DISPLAY DRYCK' || '2499',
        2564: '2564 - JUICE NEKTAR DRICKFÄRDIG' || '2564',
        2567: '2567 - MÅLTIDSDRYCK' || '2567',
        2575: '2575 - Okänd' || '2575',
        2713: '2713 - MJÖLK' || '2713',
        2950: '2950 - Naturkost Drycker' || '2950',
        2996: '2996 - Ospec låg moms' || '2996',
        3: '3 - Kemtek/Papper' || '3',
        3101: '3101 - SÄSONGSVARA JUL' || '3101',
        3102: '3102 - SÄSONGSVARA PÅSK' || '3102',
        3108: '3108 - SÄSONGSVARA PÅSK' || '3108',
        3186: '3186 - KONCENTRAT' || '3186',
        32: '32 - Extraradstexter' || '32',
        3326: '3326 - Okänd' || '3326',
        3396: '3396 - SÄSONGSVARA PÅSK' || '3396',
        3397: '3397 - SÄSONGSVARA JUL' || '3397',
        3472: '3472 - LÄSK RETURBURK' || '3472',
        3493: '3493 - Okänd' || '3493',
        3500: '3500 - CIGARETTER' || '3500',
        3510: '3510 - TÄNDARE TÄNDSTICKOR' || '3510',
        3511: '3511 - PIPRENSARE' || '3511',
        3599: '3599 - Okänd' || '3599',
        3670: '3670 - GLASSTILLBEHÖR' || '3670',
        3675: '3675 - BAKFORMAR TÅRTPAPPER' || '3675',
        3680: '3680 - Hundmat Torr' || '3680',
        3681: '3681 - Hundmat Våt' || '3681',
        3682: '3682 - Kattmat Torr' || '3682',
        3683: '3683 - Okänd' || '3683',
        3685: '3685 - AVKALKNINGSMEDEL' || '3685',
        3686: '3686 - FILTERPÅSAR KAFFE TE' || '3686',
        3747: '3747 - DJURMAT DJUPFRYST' || '3747',
        3748: '3748 - ALLRENGÖRINGSMEDEL' || '3748',
        3749: '3749 - GROVRENGÖRINGSMEDEL' || '3749',
        3750: '3750 - Okänd' || '3750',
        3751: '3751 - TVÄTTKLÄMMOR' || '3751',
        3752: '3752 - TVÄTTMEDEL' || '3752',
        3754: '3754 - MASKINDISKMEDEL' || '3754',
        3755: '3755 - SPOLGLANS' || '3755',
        3756: '3756 - HANDDISKMEDEL' || '3756',
        3757: '3757 - DISKBORSTE' || '3757',
        3758: '3758 - DISKDUK SKURDUK' || '3758',
        3759: '3759 - TVÅL' || '3759',
        3760: '3760 - TVÅL FLYTANDE' || '3760',
        3761: '3761 - HÅRSCHAMPO' || '3761',
        3762: '3762 - HÅRBALSAM' || '3762',
        3764: '3764 - HÅRVÅRD ÖVRIGT' || '3764',
        3766: '3766 - TANDKRÄM' || '3766',
        3767: '3767 - TANDBORSTE' || '3767',
        3770: '3770 - RAKARTIKLAR' || '3770',
        3772: '3772 - DEODORANTER' || '3772',
        3775: '3775 - HUDKRÄM' || '3775',
        3776: '3776 - HUDVÅRD ÖVRIGT' || '3776',
        3778: '3778 - SOLVÅRDSMEDEL' || '3778',
        3779: '3779 - VÅTSERVETTER' || '3779',
        3780: '3780 - KONDOMER' || '3780',
        3782: '3782 - BARNTILLBEHÖR' || '3782',
        3784: '3784 - BLÖJOR' || '3784',
        3785: '3785 - DAMBINDOR' || '3785',
        3786: '3786 - TROSSKYDD' || '3786',
        3788: '3788 - TAMPONGER' || '3788',
        3789: '3789 - BAKPLÅTSPAPPER' || '3789',
        3790: '3790 - FOLIE' || '3790',
        3798: '3798 - LJUS' || '3798',
        3800: '3800 - DOFTBLOCK' || '3800',
        3804: '3804 - INSEKTSMEDEL' || '3804',
        3805: '3805 - SOPPÅSAR' || '3805',
        3807: '3807 - Okänd' || '3807',
        3808: '3808 - Okänd' || '3808',
        3809: '3809 - Okänd' || '3809',
        3810: '3810 - HUSHÅLLSPAPPER' || '3810',
        3811: '3811 - FOLIEFORMAR' || '3811',
        3812: '3812 - TOALETTPAPPER' || '3812',
        3813: '3813 - PAPPERSDUKAR' || '3813',
        3814: '3814 - PAPPERSNÄSDUKAR' || '3814',
        3815: '3815 - HUSHÅLLHANDSKAR' || '3815',
        3816: '3816 - PAPPERSSERVETTER' || '3816',
        3817: '3817 - GUMMIBAND HUSHÅLLSSNÖREN' || '3817',
        3818: '3818 - SUGRÖR' || '3818',
        3826: '3826 - FRYSPÅSAR' || '3826',
        3828: '3828 - PLASTPÅSAR' || '3828',
        3829: '3829 - T-PRODUKTER' || '3829',
        3830: '3830 - EMBALLAGE WELLPAPP' || '3830',
        3831: '3831 - GRILLKOL TÄNDVÄTSKA' || '3831',
        3834: '3834 - PLÅSTER SÅRVÅRDSMEDEL KAMMAR' || '3834',
        3836: '3836 - KONTORSTILLBEHÖR' || '3836',
        3838: '3838 - KUVERT' || '3838',
        3840: '3840 - SKRIV RIT MÅLARTILLBEHÖR' || '3840',
        3842: '3842 - TEJP' || '3842',
        3850: '3850 - GLÖDLAMPOR' || '3850',
        3860: '3860 - BATTERIER ALKALISKA' || '3860',
        3872: '3872 - DAMSTRUMPOR' || '3872',
        3917: '3917 - STÄD TILLBEHÖR' || '3917',
        3920: '3920 - KASTRULLER GRYTOR STEKPANNOR' || '3920',
        3923: '3923 - TERMOMETER' || '3923',
        3924: '3924 - HUSHÅLLSPLAST' || '3924',
        3926: '3926 - BORSTAR WC STÄD' || '3926',
        3927: '3927 - Porslin' || '3927',
        3929: '3929 - SÄSONGSARTIKLAR JUL' || '3929',
        3931: '3931 - SÄSONGSARTIKLAR ÖVRIGT' || '3931',
        3933: '3933 - ARBETSHANDSKAR' || '3933',
        3935: '3935 - FRITID ÖVRIGT' || '3935',
        3941: '3941 - ENGÅNGSARTIKLAR' || '3941',
        3942: '3942 - ENGÅNGSBESTICK' || '3942',
        3943: '3943 - ENGÅNGSMUGGAR/GLAS' || '3943',
        3944: '3944 - Okänd' || '3944',
        3949: '3949 - SAN SAC ÅTERVINNING' || '3949',
        3956: '3956 - NATURKOST KOSTTILLÄGG' || '3956',
        3961: '3961 - GUMMIHANDSKAR' || '3961',
        3962: '3962 - BUTIKSGRILL' || '3962',
        3963: '3963 - BINDGARN PAKETBAND' || '3963',
        3965: '3965 - FORMAR TRÅG' || '3965',
        3966: '3966 - KANISTRAR PÅSAR' || '3966',
        3967: '3967 - FÖRPACKNINGSFILM' || '3967',
        3969: '3969 - SOPSÄCKAR BUTIK' || '3969',
        3970: '3970 - FRUKTPÅSAR FRYSPÅSAR' || '3970',
        3974: '3974 - SPELKORT' || '3974',
        3975: '3975 - BÄRKASSAR FÖR BUTIKEN' || '3975',
        3983: '3983 - KEM TEKNISKT EXPOPALL/DISPLAY' || '3983',
        3984: '3984 - PAPPER EXPOPALL/DISPLAY' || '3984',
        3990: '3990 - SPECIAL EXPOPALL/DISPLAY' || '3990',
        3997: '3997 - Ospec hög moms' || '3997',
        3998: '3998 - Okänd' || '3998',
        3999: '3999 - PANT' || '3999',
        4: '4 - Fryst' || '4',
        4101: '4101 - SÄSONGSVARA JUL' || '4101',
        42: '42 - Extraradstexter' || '42',
        4397: '4397 - SÄSONGSVARA JUL' || '4397',
        4493: '4493 - Okänd' || '4493',
        4550: '4550 - KAFFE BRYGG' || '4550',
        4575: '4575 - KAFFEKEX KAKOR' || '4575',
        4618: '4618 - SOPPOR VARMA' || '4618',
        4667: '4667 - KAKFYLLNING BAKMASSOR' || '4667',
        4709: '4709 - OSTKAKA KESO' || '4709',
        4710: '4710 - YOGHURT' || '4710',
        4716: '4716 - KÖTTBULLAR DJUPFRYST' || '4716',
        4718: '4718 - FÄRSPRODUKTER DJUPFRYST' || '4718',
        4720: '4720 - KÖTT DJUPFRYST' || '4720',
        4721: '4721 - FISK VACCUM PACKAD' || '4721',
        4722: '4722 - FISK BLOCK DJUPFRYST' || '4722',
        4724: '4724 - FISK PANERAD DJUPFRYST' || '4724',
        4727: '4727 - VEGETARISKA RÄTTER DJUPFRYST' || '4727',
        4728: '4728 - FÅGEL DJUPFRYST' || '4728',
        4729: '4729 - HAMBURGARE DJUPFRYST' || '4729',
        4730: '4730 - FÄRDIGMAT DJUPFRYST' || '4730',
        4731: '4731 - PIZZA PAJ PIROG DJUPFRYST' || '4731',
        4732: '4732 - ENPORTION DJUPFRYST' || '4732',
        4733: '4733 - POTATISPRODUKTER DJUPFRYST' || '4733',
        4734: '4734 - GRÖNSAKER DJUPFRYST' || '4734',
        4735: '4735 - okänd' || '4735',
        4736: '4736 - BÄR FRUKT DJUPFRYST' || '4736',
        4738: '4738 - SKALDJUR DJUPFRYST' || '4738',
        4740: '4740 - BRÖD DJUPFRYST' || '4740',
        4744: '4744 - GLASS STYCKSAKER DJUPFRYST' || '4744',
        4745: '4745 - GLASS TÅRTOR' || '4745',
        4746: '4746 - GLASS HUSHÅLL DJUPFRYST' || '4746',
        4888: '4888 - FAST FOOD FRYST' || '4888',
        4890: '4890 - CHARK KORV' || '4890',
        4898: '4898 - CHARK ÖVRIGT' || '4898',
        4996: '4996 - Ospec låg moms' || '4996',
        5: '5 - Pant' || '5',
        526: '526 - okänd' || '526',
        5278: '5278 - Okänd' || '5278',
        5326: '5326 - Okänd' || '5326',
        5399: '5399 - Okänd' || '5399',
        542: '542 - Okänd' || '542',
        5493: '5493 - Okänd' || '5493',
        5845: '5845 - BÖCKER' || '5845',
        5900: '5900 - TJÄNSTER' || '5900',
        5941: '5941 - ENGÅNGSARTIKLAR' || '5941',
        5996: '5996 - Ospec låg moms' || '5996',
        5997: '5997 - Ospec hög moms' || '5997',
        5998: '5998 - Ospec momsfri' || '5998',
        5999: '5999 - PANT' || '5999',
        6: '6 - Färskvaror' || '6',
        6101: '6101 - SÄSONGSVARA JUL' || '6101',
        6102: '6102 - SÄSONGSVARA PÅSK' || '6102',
        6121: '6121 - DIPP' || '6121',
        6183: '6183 - JUICE DRICKFÄRDIG' || '6183',
        6185: '6185 - KAFFE/TE/CHOKLADDRYCK' || '6185',
        6186: '6186 - KONCENTRAT' || '6186',
        62: '62 - Extraradstexter' || '62',
        6210: '6210 - SMOOTHIE' || '6210',
        623: '623 - okänd' || '623',
        6245: '6245 - ÅTERHÄMTNING/PROTEINDRYCK' || '6245',
        6397: '6397 - SÄSONGSVARA JUL' || '6397',
        6420: '6420 - DIPP' || '6420',
        6495: '6495 - CHOKLAD KAFFEDRYCKER' || '6495',
        6563: '6563 - Essenser' || '6563',
        6565: '6565 - MAJONÄS' || '6565',
        6568: '6568 - Socker' || '6568',
        6581: '6581 - okänd' || '6581',
        6582: '6582 - PASTA' || '6582',
        6588: '6588 - Ketchup' || '6588',
        6590: '6590 - Senap' || '6590',
        6592: '6592 - KRYDDOR GLAS' || '6592',
        6601: '6601 - KORVKONSERVER' || '6601',
        6609: '6609 - KYLDA DESSERTER' || '6609',
        6614: '6614 - PUDDINGAR' || '6614',
        6616: '6616 - SOPPOR EFTERRÄTT' || '6616',
        6618: '6618 - SOPPOR VARMA' || '6618',
        6619: '6619 - SÅSER MAT' || '6619',
        6636: '6636 - ANSJOVIS' || '6636',
        6641: '6641 - SKALDJURSKONSERVER' || '6641',
        6646: '6646 - KAVIAR' || '6646',
        6650: '6650 - MATOLJA' || '6650',
        6654: '6654 - DRESSING' || '6654',
        6656: '6656 - MAJONÄS' || '6656',
        6667: '6667 - KAKFYLLNING BAKMASSOR' || '6667',
        6690: '6690 - MARGARIN' || '6690',
        6692: '6692 - SMÖR' || '6692',
        6695: '6695 - AROMSMÖR' || '6695',
        6696: '6696 - OST HÅRD' || '6696',
        6697: '6697 - OST SKIVAD' || '6697',
        6698: '6698 - OST DESSERT' || '6698',
        6702: '6702 - ÄGG FÖRPACKAT' || '6702',
        6704: '6704 - Sallader' || '6704',
        6706: '6706 - SILLKONSERVER' || '6706',
        6709: '6709 - OSTKAKA KESO' || '6709',
        6710: '6710 - YOGHURT' || '6710',
        6711: '6711 - PUDDINGAR MOUSSE' || '6711',
        6712: '6712 - GRÄDDE GRÄDDFIL CR FRAICHE' || '6712',
        6713: '6713 - MJÖLK' || '6713',
        6714: '6714 - FILMJÖLK' || '6714',
        6715: '6715 - ÖVRIGT MEJERI' || '6715',
        6720: '6720 - KÖTT DJUPFRYST' || '6720',
        6721: '6721 - FISK VACCUM PACKAD' || '6721',
        6741: '6741 - okänd' || '6741',
        6889: '6889 - FAST FOOD FÄRSK' || '6889',
        6890: '6890 - CHARK KORV' || '6890',
        6892: '6892 - SMÖRGÅSMAT SKIVAD' || '6892',
        6894: '6894 - FÄRDIGMAT RULLPACK' || '6894',
        6895: '6895 - FLÄSK' || '6895',
        6896: '6896 - PASTEJ' || '6896',
        6897: '6897 - SYLTA' || '6897',
        6898: '6898 - CHARK ÖVRIGT' || '6898',
        6901: '6901 - FRUKT FÄRSK' || '6901',
        6902: '6902 - BANANER FÄRSK' || '6902',
        6903: '6903 - CITRUSFRUKTER FÄRSK' || '6903',
        6904: '6904 - PÄRON FÄRSK' || '6904',
        6905: '6905 - ÄPPLEN FÄRSK' || '6905',
        6908: '6908 - SALLAD FÄRSK' || '6908',
        6912: '6912 - LÖK FÄRSK' || '6912',
        6915: '6915 - Okänd' || '6915',
        6929: '6929 - SÄSONGSARTIKLAR JUL' || '6929',
        6941: '6941 - ' || '6941',
        6996: '6996 - Ospec låg moms' || '6996',
        6997: '6997 - ' || '6997',
        6998: '6998 - Ospec momsfri' || '6998',
        7: '7 - Specerier livs' || '7',
        7070: '7070 - HÄLSOBARS' || '7070',
        7072: '7072 - Lösvikt' || '7072',
        7101: '7101 - SÄSONGSVARA JUL' || '7101',
        7102: '7102 - SÄSONGSVARA PÅSK' || '7102',
        7121: '7121 - DIPP' || '7121',
        7141: '7141 - HÄLSOSNACKS' || '7141',
        7142: '7142 - MELLANMÅL PRODUKTER' || '7142',
        7185: '7185 - KAFFE/TE/CHOKLADDRYCK' || '7185',
        7186: '7186 - KONCENTRAT' || '7186',
        72: '72 - Extraradstexter' || '72',
        7209: '7209 - SAFT' || '7209',
        7225: '7225 - TE' || '7225',
        7308: '7308 - PRESENTASKAR &lt; 500G' || '7308',
        7366: '7366 - OINSLAGET/LÖSVIKT/PLOCK' || '7366',
        7368: '7368 - INSLAGET/LÖSVIKT/PLOCK' || '7368',
        7392: '7392 - ENERGIPRODUKTER' || '7392',
        7393: '7393 - NATURGODIS' || '7393',
        7395: '7395 - EXPO DISPLAY PALLAR ETC' || '7395',
        7397: '7397 - SÄSONGSVARA JUL' || '7397',
        7494: '7494 - ÖVRIGA DRYCKER' || '7494',
        7495: '7495 - CHOKLAD KAFFEDRYCKER' || '7495',
        7550: '7550 - KAFFE BRYGG' || '7550',
        7551: '7551 - KAFFE KOK' || '7551',
        7552: '7552 - SNABBKAFFE' || '7552',
        7554: '7554 - OBOY CACAO' || '7554',
        7556: '7556 - TE' || '7556',
        7557: '7557 - VENDING AUTOMATPROD' || '7557',
        7558: '7558 - SAFT' || '7558',
        7563: '7563 - Essenser' || '7563',
        7565: '7565 - MAJONÄS' || '7565',
        7566: '7566 - JUICE KONCENTRAT' || '7566',
        7567: '7567 - MÅLTIDSDRYCK' || '7567',
        7568: '7568 - SOCKER' || '7568',
        7569: '7569 - SIRAP' || '7569',
        7570: '7570 - SÖTNINGSMEDEL' || '7570',
        7571: '7571 - PEPPARKAKOR' || '7571',
        7572: '7572 - BRÖD HÅRT' || '7572',
        7573: '7573 - STRÖBRÖD SKORPOR' || '7573',
        7574: '7574 - SMÖRGÅSKEX' || '7574',
        7575: '7575 - KAFFEKEX KAKOR' || '7575',
        7576: '7576 - MJÖL' || '7576',
        7577: '7577 - TÅRTBOTTNAR BISKVIER' || '7577',
        7578: '7578 - GRYNER' || '7578',
        7580: '7580 - RIS' || '7580',
        7582: '7582 - PASTA' || '7582',
        7586: '7586 - POTATISMOS PULVER' || '7586',
        7588: '7588 - KETCHUP' || '7588',
        7589: '7589 - CHILISÅS TOMATPURE' || '7589',
        7590: '7590 - SENAP' || '7590',
        7592: '7592 - KRYDDOR GLAS' || '7592',
        7594: '7594 - KRYDDOR PÅSE' || '7594',
        7595: '7595 - KRYDDOR STORKÖK' || '7595',
        7596: '7596 - SALT MED JOD' || '7596',
        7598: '7598 - GRÖNSAKSKONSERVER' || '7598',
        7600: '7600 - GURKA KONSERV' || '7600',
        7601: '7601 - KORVKONSERVER' || '7601',
        7602: '7602 - RÖDBETOR KONSERV' || '7602',
        7604: '7604 - FRUKTKONSERV' || '7604',
        7606: '7606 - NN' || '7606',
        7607: '7607 - GELE' || '7607',
        7608: '7608 - SYLT' || '7608',
        7610: '7610 - MARMELAD' || '7610',
        7612: '7612 - KRÄMER' || '7612',
        7613: '7613 - HONUNG' || '7613',
        7614: '7614 - PUDDINGAR' || '7614',
        7616: '7616 - SOPPOR EFTERRÄTT' || '7616',
        7618: '7618 - SOPPOR VARMA' || '7618',
        7619: '7619 - SÅSER MAT' || '7619',
        7620: '7620 - SOPPOR TORR' || '7620',
        7621: '7621 - SOYA' || '7621',
        7623: '7623 - ÄTTIKA' || '7623',
        7624: '7624 - SÅSER DESSERT' || '7624',
        7626: '7626 - SVAMPKONSERVER' || '7626',
        7628: '7628 - STUVNINGAR' || '7628',
        7632: '7632 - KÖTTKONSERVER' || '7632',
        7641: '7641 - SKALDJURSKONSERVER' || '7641',
        7644: '7644 - TONFISK' || '7644',
        7646: '7646 - KAVIAR' || '7646',
        7650: '7650 - MATOLJA' || '7650',
        7652: '7652 - GRILLOLJA' || '7652',
        7654: '7654 - DRESSING' || '7654',
        7655: '7655 - DRESSING MIX' || '7655',
        7656: '7656 - MAJONÄS' || '7656',
        7658: '7658 - BARNMAT' || '7658',
        7660: '7660 - VÄLLING BARN' || '7660',
        7661: '7661 - MUSLI' || '7661',
        7663: '7663 - FLINGOR' || '7663',
        7665: '7665 - BAKPULVER VANILJSOCKER' || '7665',
        7667: '7667 - KAKFYLLNING BAKMASSOR' || '7667',
        7668: '7668 - BRÖD KAKMIXER' || '7668',
        7669: '7669 - MANDEL COCOSFLINGOR' || '7669',
        7670: '7670 - GLASSTILLBEHÖR' || '7670',
        7671: '7671 - MJÖLKERSÄTTNING' || '7671',
        7672: '7672 - VÅFFELMIX' || '7672',
        7676: '7676 - FRUKTSALT SAMARIN' || '7676',
        7677: '7677 - BLOCKCHOKLAD' || '7677',
        7678: '7678 - TACO MED TILLBEHÖR' || '7678',
        7681: '7681 - HUNDMAT VÅT' || '7681',
        7685: '7685 - AVKALKNINGSMEDEL' || '7685',
        7700: '7700 - OST MJUK' || '7700',
        7702: '7702 - ÄGG FÖRPACKAT' || '7702',
        7706: '7706 - SILLKONSERVER' || '7706',
        7712: '7712 - GRÄDDE GRÄDDFIL CR FRAICHE' || '7712',
        7744: '7744 - GLASS STYCKSAKER DJUPFRYST' || '7744',
        7745: '7745 - GLASS TÅRTOR' || '7745',
        7836: '7836 - KONTORSTILLBEHÖR' || '7836',
        7890: '7890 - CHARK KORV' || '7890',
        7898: '7898 - CHARK ÖVRIGT' || '7898',
        7912: '7912 - LÖK FÄRSK' || '7912',
        7941: '7941 - ENGÅNGSARTIKLAR' || '7941',
        7950: '7950 - NATURKOST DRYCKER' || '7950',
        7956: '7956 - NATURKOST KOSTTILLÄGG' || '7956',
        7958: '7958 - NATURKOST RISKAKOR' || '7958',
        7987: '7987 - KOLONIAL EXPOPALL/DISPLAY' || '7987',
        7996: '7996 - Ospec låg moms' || '7996',
        8: '8 - Tobak' || '8',
        82: '82 - Extraradstexter' || '82',
        8500: '8500 - CIGARETTER' || '8500',
        8502: '8502 - CIGARRER' || '8502',
        8504: '8504 - CIGARILLER' || '8504',
        8505: '8505 - RULL/PIPTOBAK' || '8505',
        8506: '8506 - ' || '8506',
        8507: '8507 - SNUS LÅG MOMS NIKOTINFRITT' || '8507',
        8508: '8508 - SNUS' || '8508',
        8509: '8509 - SNUS PORTION' || '8509',
        8510: '8510 - TÄNDARE TÄNDSTICKOR' || '8510',
        8512: '8512 - TOBAKSTILLBEHÖR' || '8512',
        8956: '8956 - Okänd' || '8956',
        8996: '8996 - Ospec låg moms' || '8996',
        8997: '8997 - Ospec hög moms' || '8997',
        9: '9 - Frakt/Tjänster' || '9',
        91: '91 - Extra' || '91',
        9122: '9122 - DIPP EXPODISPLAY' || '9122',
        9162: '9162 - CIDER PET 1.5L' || '9162',
        92: '92 - Extraradstexter' || '92',
        9270: '9270 - Okänd' || '9270',
        9278: '9278 - Okänd' || '9278',
        9340: '9340 - TUGGUMMI' || '9340',
        9395: '9395 - EXPO DISPLAY PALLAR ETC' || '9395',
        9542: '9542 - Okänd' || '9542',
        9685: '9685 - AVKALKNINGSMEDEL' || '9685',
        9900: '9900 - TJÄNSTER' || '9900',
        9923: '9923 - TERMOMETER' || '9923',
        9935: '9935 - FRITID ÖVRIGT' || '9935',
        9941: '9941 - ENGÅNGSARTIKLAR' || '9941',
        9965: '9965 - FORMAR TRÅG' || '9965',
        9990: '9990 - SPECIAL EXPOPALL/DISPLAY' || '9990',
        9996: '9996 - Ospec låg moms' || '9996',
        9997: '9997 - Ospec hög moms' || '9997',
        9998: '9998 - Ospec momsfri' || '9998',
    },
    supplier: 'Leverantör' || 'supplier',
    owningCustomerSubUnit: 'Ägd av kund' || 'owningCustomerSubUnit',
    brand: 'Varumärke' || 'brand',
    name: 'Artikelnamn (syns i bokföringssystem vid integration)' || 'name',
    shortName: 'E-handelsnamn (framgår på E-handel &amp; externa inköpssystem)' ||
        'shortName',
    image: 'Bild' || 'image',
    images: 'Bilder' || 'images',
    VAT: 'Moms (%)' || 'VAT',
    orderUnit: 'Försäljningsenhet' || 'orderUnit',
    orderUnits: {
        package: 'förpackning' || 'package',
        single: 'styck' || 'single',
        weight: 'vikt' || 'weight',
    },
    supplierOrderUnit: 'Försäljningsenhet i leverantörens system' || 'supplierOrderUnit',
    minWeightIncrement: 'Minsta enhet vid viktförsäljning (kg)' || 'minWeightIncrement',
    priceComparisonUnit: 'Prisjämförelsenhet' || 'priceComparisonUnit',
    priceComparisonUnits: {
        unit: 'styck - kr/st' || 'unit',
        kg: 'kg - kr/kg' || 'kg',
        liter: 'liter - kr/l' || 'liter',
    },
    colliSize: 'Antal försäljningsenheter per kolli' || 'colliSize',
    baseUnitSize: 'Konsumentförpackningar per försäljningsenhet' || 'baseUnitSize',
    caseUnitSize: 'Antal försäljningsenheter per distributionsenhet' || 'caseUnitSize',
    caseUnitsPerPalletLayer: 'Antal kolli per lav' || 'caseUnitsPerPalletLayer',
    caseUnitsPerPallet: 'Antal kolli per pall' || 'caseUnitsPerPallet',
    volume: 'Volym per styck (liter)' || 'volume',
    weight: 'Bruttovikt per styck (g)' || 'weight',
    netWeight: 'Nettovikt per styck (g)' || 'netWeight',
    caseWeight: 'Bruttovikt på dfp nivå (g)' || 'caseWeight',
    caseNetWeight: 'Nettovikt på dfp nivå (g)' || 'caseNetWeight',
    purchasePrice: 'Inköpspris' || 'purchasePrice',
    salesPrice: 'Försäljningspris per försäljningsenhet (exkl. eventuell pant)' ||
        'salesPrice',
    retailPrice: 'Försäljningspris per styck på Stockfiller (exkl. eventuell pant)' ||
        'retailPrice',
    currency: 'Valuta' || 'currency',
    supplierPurchasePrice: 'Lagervärde per styck' || 'supplierPurchasePrice',
    alcoholPercentage: 'Alkoholprocent' || 'alcoholPercentage',
    alcoholTaxPaid: 'Alkoholskatt betalad (kräver inte EMCS)' || 'alcoholTaxPaid',
    alcoholTaxClass: 'Skatteklass' || 'alcoholTaxClass',
    alcoholTaxClasses: {
        Alcoholfree: 'Utan alkohol' || 'Alcoholfree',
        Beer: 'Öl' || 'Beer',
        Wine: 'Vin och andra jästa drycker än vin och öl' || 'Wine',
        MidRange: 'Mellanklass' || 'MidRange',
        Spirits: 'Sprit' || 'Spirits',
    },
    alcoholTax: 'Alkoholskatt per st' || 'alcoholTax',
    requiresAlcoholPermit: 'Kräver alkoholtillstånd' || 'requiresAlcoholPermit',
    shelfLife: 'Hållbarhet från produktion till och med bäst-före' || 'shelfLife',
    shelfLives: {
        short: 'Kort hållbarhet (upp till 4 månader)' || 'short',
        medium: 'Mellan hållbarhet (från 4 till 11 månader)' || 'medium',
        long: 'Lång hållbarhet (11 månader eller mer)' || 'long',
        special: 'Special (Annat har avtalats)' || 'special',
    },
    container: 'Förpackningstyp' || 'container',
    containers: {
        Can: 'Burk' || 'Can',
        Bottle: 'Flaska' || 'Bottle',
        Keg: 'Fat' || 'Keg',
        Tetra: 'Tetra' || 'Tetra',
        Paper: 'Pappburk' || 'Paper',
        BIB: 'Bag-in-box/Ståpåse' || 'BIB',
        Bag: 'Påse' || 'Bag',
        Pet: 'Pet' || 'Pet',
        Box: 'Ask' || 'Box',
        Pot: 'Kruka' || 'Pot',
        Carton: 'Kartong' || 'Carton',
        'Plastic can': 'Dunk' || 'Plastic can',
        TinCan: 'Konserv' || 'TinCan',
        'Vacuum-sealed': 'Vakuumförpackning' || 'Vacuum-sealed',
        Other: 'Annat' || 'Other',
    },
    recycleType: 'Panttyp' || 'recycleType',
    recycleTypes: {
        none: 'Ingen pant' || 'none',
        PET1: 'PET upp till en liter' || 'PET1',
        PET2: 'PET över en liter' || 'PET2',
        aluminiumCan: 'Aluminiumburk' || 'aluminiumCan',
        glassBottle33cl: '33cl glasflaska' || 'glassBottle33cl',
        glassBottle50cl: '50cl glasflaska' || 'glassBottle50cl',
        other: 'Annat' || 'other',
    },
    recycleTypeContainer: 'Panttyp brätte' || 'recycleTypeContainer',
    recycleTypeContainers: {
        none: 'Ingen pant' || 'none',
        recyclableQuarterTray: '1/4 BRÄTTE PANT - 5699-76' || 'recyclableQuarterTray',
        trayLarge: 'BRÄTTE STOR - 5699-77' || 'trayLarge',
    },
    recycleContainerMultiplier: 'Multipel för brätte' || 'recycleContainerMultiplier',
    recycleTypePallet: 'Panttyp pall' || 'recycleTypePallet',
    recycleTypePallets: {
        none: 'Ingen pant' || 'none',
        recyclableGreySrsPlasticPallet: 'PANT PLASTPALL GRÅ (SRS) - 5699-1084' ||
            'recyclableGreySrsPlasticPallet',
        recyclableWoodenHalfPallet: 'PANT HALVPALL TRÄ - 5699-90' || 'recyclableWoodenHalfPallet',
        recyclableEuroWoodPallet: 'PANT EUROPALL TRÄ - 5699-94' || 'recyclableEuroWoodPallet',
        recyclableBPallet: 'PANT B-PALL - 5699-93' || 'recyclableBPallet',
        recyclableAPallet: 'PANT A-PALL 6 5699-92' || 'recyclableAPallet',
        recylablePlasticPallet: 'PLASTPALL PANT - 5699-1038' || 'recylablePlasticPallet',
        reyclingFeePlasticPallet: 'PANTAVG PLASTPALL - 3183-182' || 'reyclingFeePlasticPallet',
        recyclablePlasticHalfPallet: 'PANTPALL PLAST 1/2 - 5699-57' || 'recyclablePlasticHalfPallet',
        greySrsPlasticPallet: 'PLASTPALL GRÅ (SRS) - 5699-100' || 'greySrsPlasticPallet',
        srsBox: 'SRS LÅDA - 5699-140' || 'srsBox',
        srsBox2: 'SRS-LÅDA - 5699-1043' || 'srsBox2',
    },
    recycleAmount: 'Pantkostnad (exkl. moms)' || 'recycleAmount',
    salesStart: 'Säljperiod startar' || 'salesStart',
    salesEnd: 'Säljperiod slutar' || 'salesEnd',
    markedAsOutOfStock: 'Markerad som slut' || 'markedAsOutOfStock',
    isCampaign: 'Kampanj' || 'isCampaign',
    campaignPrice: 'Kampanjpris' || 'campaignPrice',
    active: 'Aktiverad' || 'active',
    isNotForPublishing: 'Skall aldrig publiceras' || 'isNotForPublishing',
    isPublishedOnOurStore: 'Publicerad på Flaivy.com' || 'isPublishedOnOurStore',
    isPublishedOnWhitelabel: 'Publicerad på egen marknadsplats' || 'isPublishedOnWhitelabel',
    isPublishedOnPro: 'Publicerad på Qvanti (Inköpssystem)' || 'isPublishedOnPro',
    isPublishedOnStockfiller: 'Publicerad på Stockfiller' || 'isPublishedOnStockfiller',
    description: 'Beskrivning' || 'description',
    shortDescription: 'Kort beskrivning' || 'shortDescription',
    ingredientsDeclaration: 'Innehållsförteckning' || 'ingredientsDeclaration',
    nutritionDeclaration: 'Näringsinnehåll' || 'nutritionDeclaration',
    nutritionInfo: 'Näringsinfo' || 'nutritionInfo',
    customFields: 'Extrafält' || 'customFields',
    MSRCriteria: 'MSRKriteria' || 'MSRCriteria',
    showInNews: 'Nyhetsmarkerad' || 'showInNews',
    promoteAsNewStart: 'Nyhetsperiod startar' || 'promoteAsNewStart',
    promoteAsNewEnd: 'Nyhetsperiod slutar' || 'promoteAsNewEnd',
    onCopack: 'Är en co-pack-artikel' || 'onCopack',
    isEco: 'Ekologisk' || 'isEco',
    isVegan: 'Veganskt' || 'isVegan',
    isGelatinFree: 'Gelatinfritt' || 'isGelatinFree',
    isSugarFree: 'Sockerfritt (Utan tillsatt socker)' || 'isSugarFree',
    isLactoseFree: 'Laktosfritt' || 'isLactoseFree',
    isPalmOilFree: 'Fritt från palmolja' || 'isPalmOilFree',
    isFrozen: 'Frysvara' || 'isFrozen',
    isRefrigerated: 'Kylvara' || 'isRefrigerated',
    isFoam: 'Skumgodis' || 'isFoam',
    isCoated: 'Dragerad' || 'isCoated',
    isFudge: 'Fudge' || 'isFudge',
    isGelatinous: 'Gele' || 'isGelatinous',
    isLiquorice: 'Lakrits' || 'isLiquorice',
    isHardCandy: 'Karamell' || 'isHardCandy',
    isExpo: 'Expo vara' || 'isExpo',
    isWrapped: 'Inslagen vara' || 'isWrapped',
    storageTemperature: 'Förvaringstemperatur' || 'storageTemperature',
    storageTemperatures: {
        frozen: 'Fryst' || 'frozen',
        refrigerated: 'Kyld' || 'refrigerated',
    },
    origin: 'Ursprung' || 'origin',
    isAvailableForPreorder: 'Förbokningsartikel' || 'isAvailableForPreorder',
    isBlockedForPurchaseOrders: 'Spärrad för inköp/inleverans' || 'isBlockedForPurchaseOrders',
    goesWith: 'Passar med' || 'goesWith',
    appearance: 'Utseende' || 'appearance',
    scent: 'Doft' || 'scent',
    taste: 'Smak' || 'taste',
    grapes: 'Druva' || 'grapes',
    vintage: 'Årgång' || 'vintage',
    seal: 'Förslutning' || 'seal',
    seals: {
        'CROWN CORK CAP': 'Champangekork' || 'CROWN CORK CAP',
        'GLASS CAP': 'Kapsyl' || 'GLASS CAP',
        'NATURAL CORK': 'Naturkork' || 'NATURAL CORK',
        'SCREW CAP': 'Skruvkork' || 'SCREW CAP',
        'SYNTHETIC CORK': 'Syntetkork' || 'SYNTHETIC CORK',
        UNCLASSIFIED: 'Oklassificerad' || 'UNCLASSIFIED',
        UNIDENTIFIED: 'Okänd' || 'UNIDENTIFIED',
    },
    isAlwaysOrderable: 'Alltid beställningsbar (oavsett lagersaldo)' || 'isAlwaysOrderable',
    quantityInStock: 'Antal i lager (st)' || 'quantityInStock',
    stockWarning: 'Lagervarning' || 'stockWarning',
    GTIN: 'GTIN Artikelnivå (KFP)' || 'GTIN',
    boxGTIN: 'GTIN Förpackningsnivå (DFP)' || 'boxGTIN',
    palletGTIN: 'GTIN på pall' || 'palletGTIN',
    recycleGTIN: 'Pant GTIN Artikelnivå (KFP)' || 'recycleGTIN',
    purchaseInformation: 'Information för inköp' || 'purchaseInformation',
    utilityArticle: 'Specialartikel' || 'utilityArticle',
    systembolagetArticleNumber: 'Artikelnummer på Systembolaget' || 'systembolagetArticleNumber',
    systembolagetSalesPrice: 'Försäljningspris per st mot systembolaget' || 'systembolagetSalesPrice',
    keywords: 'Sökord' || 'keywords',
    exactaDisposableQuantityInStock: 'Disponibelt lagersaldo för Systembolaget (Exacta) (st)' ||
        'exactaDisposableQuantityInStock',
    exactaQuantityInStock: 'Lagersaldo för Systembolaget (Exacta) (st)' || 'exactaQuantityInStock',
    purchaseAccount: 'Purchase Account' || 'purchaseAccount',
    salesAccount: 'Sales Account' || 'salesAccount',
    salesAccounts: {
        3005: '3005' || '3005',
        3004: '3004' || '3004',
        3011: '3011' || '3011',
        3010: '3010' || '3010',
        3017: '3017' || '3017',
        3014: '3014' || '3014',
        3000: '3000' || '3000',
    },
    knNumber: 'KN-Nummer' || 'knNumber',
    knNumbers: {
        15071010: '15071010 - Soya-bean oil, crude, whether or not degummed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15071010',
        15079010: '15079010 - Soya-bean oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15079010',
        15081010: '15081010 - Groundnut oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15081010',
        15089010: '15089010 - Groundnut oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15089010',
        15092000: '15092000 - Extra virgin olive oil' || '15092000',
        15093000: '15093000 - Virgin olive oil, not chemically modified' || '15093000',
        15094000: '15094000 - Virgin olive oil other than extra virgin, but not chemically modified' ||
            '15094000',
        15099000: '15099000 - Other than virgin olive oil, not chemically modified' ||
            '15099000',
        15101000: '15101000 - Other oils, Crude olive pomace oil, obtained solely from olives, whether or not refined, but not chemically modified' ||
            '15101000',
        15109000: '15109000 - Oils, other than Crude olive pomace oil, obtained solely from olives, whether or not refined, but not chemically modified' ||
            '15109000',
        15111010: '15111010 - Palm oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15111010',
        15119011: '15119011 - Solid fractions of other palm oil than crude palm oil, whether or not refined, in immediate packings of a net content not exceeding 1 kg' ||
            '15119011',
        15119019: '15119019 - Solid fractions of other palm oil than crude palm oil, not in immediate packings of a net content not exceeding 1 kg' ||
            '15119019',
        15119091: '15119091 - Liquid fractions of other palm oil than crude palm oil, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15119091',
        15121110: '15121110 - Sunflower-seed or safflower oil or cotton-seed, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15121110',
        15121910: '15121910 - Sunflower-seed or safflower oil or cotton-seed, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15121910',
        15122110: '15122110 - Cotton-seed oil, crude, whether or not gossypol has been removed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15122110',
        15122910: '15122910 - Cotton-seed oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15122910',
        15131110: '15131110 - Crude coconut oil for technical or industrial use' ||
            '15131110',
        15131911: '15131911 - Solid fractions of coconut (copra) oil, whether or not refined, in immediate packings of a net content not exceeding 1 kg' ||
            '15131911',
        15131919: '15131919 - Solid fractions of coconut (copra) oil, whether or not refined, not in immediate packings of a net content exceeding 1 kg' ||
            '15131919',
        15131930: '15131930 - Not solid fractions of coconut (copra) oil, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15131930',
        15132110: '15132110 - Palm kernel or babassu oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15132110',
        15132911: '15132911 - Solid fractions of palm kernel or babassu oil, not crude, whether or not refined, in immediate packings of a net content not exceeding 1 kg' ||
            '15132911',
        15132919: '15132919 - Solid fractions of palm kernel or babassu oil, whether or not refined, not crude, not in immediate packings of a net content exceeding 1 kg' ||
            '15132919',
        15132930: '15132930 - Liquid fractions of palm kernel or babassu oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15132930',
        15141110: '15141110 - Low erucic acid rape or colza oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15141110',
        15141910: '15141910 - Low erucic acid rape or colza oil, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15141910',
        15149110: '15149110 - Mustard oil, whether or not refined, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15149110',
        15149910: '15149910 - Mustard oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15149910',
        15151100: '15151100 - Linseed oil, crude' || '15151100',
        15151910: '15151910 - Linseed oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15151910',
        15152110: '15152110 - Maize (corn) oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15152110',
        15152910: '15152910 - Maize (corn) oil, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15152910',
        15153090: '15153090 - Castor oil, whether or not refined, for technical or industrial uses other than the production of amino-undecanoic acid for use in the manufacture of synthetic textile fibres or of artificial plastic materials' ||
            '15153090',
        15155011: '15155011 - Sesame oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15155011',
        15155091: '15155091 - Sesame oil, whether or not refined, not crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15155091',
        15156011: '15156011 - Microbial fats and oils and their fractions, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15156011',
        15156060: '15156060 - Microbial fats and oils and their fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15156060',
        15159011: '15159011 - Tung oil; jojoba and oiticica oils; myrtle wax and Japan wax; their fractions' ||
            '15159011',
        15159021: '15159021 - Tobacco-seed oil, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15159021',
        15159031: '15159031 - Tobacco-seed oil and its fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15159031',
        15159040: '15159040 - Other fixed vegetable fats and oils, crude, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15159040',
        15159060: '15159060 - Other fixed vegetable fats and oils and their fractions, not crude, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15159060',
        15161010: '15161010 - Animal fats and oils and their fractions in immediate packings of a net content not exceeding 1 kg' ||
            '15161010',
        15161090: '15161090 - Animal fats and oils and their fractions in immediate packings of a net content exceeding 1 kg' ||
            '15161090',
        15162010: '15162010 - Hydrogenated castor oil, so called &quot;opal-wax&quot;' ||
            '15162010',
        15162091: '15162091 - Vegetable fats and oils and their fractions in immediate packings of a net content not exceeding 1 kg' ||
            '15162091',
        15162095: '15162095 - Colza, linseed, rapeseed, sunflower-seed, illipe, karite, makore, touloucouna or babassu oils, whether or not refined, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15162095',
        15163091: '15163091 - Microbial fats and oils and their fractions in immediate packings of a net content not exceeding 1kg' ||
            '15163091',
        15171010: '15171010 - Margarine, excluding liquid margarine, containing, by weight, more than 10% but not more than 15% of milkfats' ||
            '15171010',
        15171090: '15171090 - Margarine, excluding liquid margarine, containing, by weight, no more than 10% of milkfats' ||
            '15171090',
        15179010: '15179010 - Edible mixtures or preparations of animals or vegetable fats or oil or of fractions of different fats or oils, containing, by weight, more than 10% but not more than 15% of milkfats' ||
            '15179010',
        15179091: '15179091 - Fixed vegetable oils, fluid, mixed' || '15179091',
        15179093: '15179093 - Edible mixtures or preparations of a kind used as mould-release preparations' ||
            '15179093',
        15179099: '15179099 - Other edible mixtures or preparations of a kind used as mould-release preparations' ||
            '15179099',
        15180010: 'Linoxyn' || '15180010',
        15180031: '15180031 - Crude fixed vegetable oils, fluid, mixed, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15180031',
        15180039: '15180039 - Fixed vegetable oils, fluid, for technical or industrial uses other than the manufacture of foodstuffs for human consumption' ||
            '15180039',
        15180095: '15180095 - Inedible mixtures or preparations of animal or of animal, vegetable or microbial fats and oils and their fractions' ||
            '15180095',
        22030001: '22030001 - Beer made from malt in bottles holding 10 litres or less' ||
            '22030001',
        22030009: '22030009 - Beer made from malt in containers other than bottles holding 10 litres or less' ||
            '22030009',
        22030010: '22030010 - Beer made from malt in containers holding more than 10 litres' ||
            '22030010',
        22041011: '22041011 - Champagne with a protected designation of origin (PDO)' ||
            '22041011',
        22041013: '22041013 - Cava with a protected designation of origin (PDO)' ||
            '22041013',
        22041015: '22041015 - Prosecco with a protected designation of origin (PDO)' ||
            '22041015',
        22041091: '22041091 - Asti spumante with a protected designation of origin (PDO)' ||
            '22041091',
        22041093: '22041093 - Other sparkling wine with a protected designation of origin (PDO)' ||
            '22041093',
        22041094: '22041094 - Sparkling wine with a protected geographical indication (PGI)' ||
            '22041094',
        22041096: '22041096 - Other varietal sparkling wines' || '22041096',
        22041098: '22041098 - Other sparkling wine' || '22041098',
        22042106: '22042106 - Wine in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar meas...; with a protected designation of origin (PDO)' ||
            '22042106',
        22042107: '22042107 - Wine in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar me...; with a protected geographical indication (PGI)' ||
            '22042107',
        22042108: '22042108 - Other varietal wines in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; other varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temper...' ||
            '22042108',
        22042109: '22042109 - Non-varietal wine in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; non-varietal wine otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature...' ||
            '22042109',
        22042111: '22042111 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Alsace in containers holding 2 litres or less' ||
            '22042111',
        22042112: '22042112 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding 2 litres or less' ||
            '22042112',
        22042113: '22042113 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne in containers holding 2 litres or less' ||
            '22042113',
        22042117: '22042117 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire in containers holding 2 litres or less' ||
            '22042117',
        22042118: '22042118 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Mosel in containers holding 2 litres or less' ||
            '22042118',
        22042119: '22042119 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Pfalz in containers holding 2 litres or less' ||
            '22042119',
        22042122: '22042122 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rheinhessen in containers holding 2 litres or less' ||
            '22042122',
        22042123: '22042123 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Tokaj in containers holding 2 litres or less' ||
            '22042123',
        22042124: '22042124 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Lazio in containers holding 2 litres or less' ||
            '22042124',
        22042126: '22042126 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Toscana in containers holding 2 litres or less' ||
            '22042126',
        22042127: '22042127 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Trentino, Alto Adige and Friuli in containers holding 2 litres or less' ||
            '22042127',
        22042128: '22042128 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Veneto in containers holding 2 litres or less' ||
            '22042128',
        22042131: '22042131 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Sicilia in containers holding 2 litres or less' ||
            '22042131',
        22042132: '22042132 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vinho Verde in containers holding 2 litres or less' ||
            '22042132',
        22042134: '22042134 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Penedés in containers holding 2 litres or less' ||
            '22042134',
        22042136: '22042136 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rioja in containers holding 2 litres or less' ||
            '22042136',
        22042137: '22042137 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Valencia in containers holding 2 litres or less' ||
            '22042137',
        22042138: '22042138 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, produced in the Community in a region other than Alsace, Bordeaux, Bourgogne, Val de Loire, ...' ||
            '22042138',
        22042142: '22042142 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding 2 litres or less' ||
            '22042142',
        22042143: '22042143 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne in containers holding 2 litres or less' ||
            '22042143',
        22042144: '22042144 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding 2 litres or less' ||
            '22042144',
        22042146: '22042146 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding 2 litres or less' ||
            '22042146',
        22042147: '22042147 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding 2 litres or less' ||
            '22042147',
        22042148: '22042148 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire in containers holding 2 litres or less' ||
            '22042148',
        22042161: '22042161 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Sicilia in containers holding 2 litres or less' ||
            '22042161',
        22042162: '22042162 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte in containers holding 2 litres or less' ||
            '22042162',
        22042166: '22042166 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Toscana in containers holding 2 litres or less' ||
            '22042166',
        22042167: '22042167 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Trentino and Alto Adige in containers holding 2 litres or less' ||
            '22042167',
        22042168: '22042168 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Veneto in containers holding 2 litres or less' ||
            '22042168',
        22042169: '22042169 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Dão, Bairrada and Douro in containers holding 2 litres or less' ||
            '22042169',
        22042171: '22042171 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Navarra in containers holding 2 litres or less' ||
            '22042171',
        22042174: '22042174 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Penedés in containers holding 2 litres or less' ||
            '22042174',
        22042176: '22042176 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Rioja in containers holding 2 litres or less' ||
            '22042176',
        22042177: '22042177 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Valdepeñas in containers holding 2 litres or less' ||
            '22042177',
        22042178: '22042178 - Wine,other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, produced in the Community in a region other than Bordeaux, Bourgogne, Beaujolais...' ||
            '22042178',
        22042179: '22042179 - White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less' ||
            '22042179',
        22042180: '22042180 - Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less' ||
            '22042180',
        22042181: '22042181 - White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, other than wine with a protected designation of origin (PDO) or a protected geographical indication ...' ||
            '22042181',
        22042182: '22042182 - Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less, other than wine with a protected designation of origin (PDO) or a protected geographical...' ||
            '22042182',
        22042183: '22042183 - Non-varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less' ||
            '22042183',
        22042184: '22042184 - Non-varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding 2 litres or less' ||
            '22042184',
        22042185: '22042185 - Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042185',
        22042186: '22042186 - Sherry wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042186',
        22042187: '22042187 - Marsala wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042187',
        22042188: '22042188 - Samos and Muscat de Lemnos wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042188',
        22042189: '22042189 - Port wine of an alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042189',
        22042190: '22042190 - Wine of an actual alcoholic strength by volume exceeding 15% vol in containers holding 2 litres or less, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and Setubal ...' ||
            '22042190',
        22042191: '22042191 - Wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding 2 litres or less, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042191',
        22042193: '22042193 - White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less' ||
            '22042193',
        22042194: '22042194 - Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less' ||
            '22042194',
        22042195: '22042195 - Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less' ||
            '22042195',
        22042196: '22042196 - Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding 2 litres or less' ||
            '22042196',
        22042197: '22042197 - Non-varietal white wine, not produced in the Community, in containers holding 2 litres or less' ||
            '22042197',
        22042198: '22042198 - Non-varietal wine, other than white, not produced in the Community, in containers holding 2 litres or less' ||
            '22042198',
        22042210: '22042210 - Wine in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...' ||
            '22042210',
        22042222: '22042222 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding more than 2 litres but not more than 10 litres' ||
            '22042222',
        22042223: '22042223 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne (Burgundy) in containers holding more than 2 litres but not more than 10 litres' ||
            '22042223',
        22042224: '22042224 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding more than 2 litres but not more than 10 litres' ||
            '22042224',
        22042226: '22042226 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding more than 2 litres but not more than 10 litres' ||
            '22042226',
        22042227: '22042227 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding more than 2 litres but not more than 10 litres' ||
            '22042227',
        22042228: '22042228 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire (Loire Valley) in containers holding more than 2 litres but not more than 10 litres' ||
            '22042228',
        22042232: '22042232 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte (Piedmont) in containers holding more than 2 litres but not more than 10 litres' ||
            '22042232',
        22042233: '22042233 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Tokaj in containers holding more than 2 litres but not more than 10 litres' ||
            '22042233',
        22042238: '22042238 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community in a region other than Bordeaux, Bou...' ||
            '22042238',
        22042278: '22042278 - Wine,other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community in a region other than B...' ||
            '22042278',
        22042279: '22042279 - White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres' ||
            '22042279',
        22042280: '22042280 - Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres' ||
            '22042280',
        22042281: '22042281 - White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, other than wine with a protected designation of origin (PDO) or a prot...' ||
            '22042281',
        22042282: '22042282 - Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, other than wine with a protected designation of origin (PD...' ||
            '22042282',
        22042283: '22042283 - Non varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres' ||
            '22042283',
        22042284: '22042284 - Non varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres' ||
            '22042284',
        22042285: '22042285 - Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042285',
        22042286: '22042286 - Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042286',
        22042288: '22042288 - Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042288',
        22042290: '22042290 - Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other t...' ||
            '22042290',
        22042291: '22042291 - Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 2 litres but not more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042291',
        22042293: '22042293 - White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042293',
        22042294: '22042294 - Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042294',
        22042295: '22042295 - Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042295',
        22042296: '22042296 - Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042296',
        22042297: '22042297 - Non-varietal white wine, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042297',
        22042298: '22042298 - Non-varietal wine, other than white, not produced in the Community, in containers holding more than 2 litres but not more than 10 litres' ||
            '22042298',
        22042910: '22042910 - Wine in bottles with &quot;mushroom&quot; stoppers held in place by ties or fastenings; wine, otherwise put up, with an excess pressure due to carbon dioxide in solution of not less than 1 bar but less than 3 bar measured at a temperature of 20°C, in containers h...' ||
            '22042910',
        22042922: '22042922 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bordeaux in containers holding more than 10 litres' ||
            '22042922',
        22042923: '22042923 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Bourgogne (Burgundy) in containers holding more than 10 litres' ||
            '22042923',
        22042924: '22042924 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Beaujolais in containers holding more than 10 litres' ||
            '22042924',
        22042926: '22042926 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Vallée du Rhône in containers holding more than 10 litres' ||
            '22042926',
        22042927: '22042927 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Languedoc-Roussillon in containers holding more than 10 litres' ||
            '22042927',
        22042928: '22042928 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Val de Loire (Loire Valley) in containers holding more than 10 litres' ||
            '22042928',
        22042932: '22042932 - Wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. produced in Piemonte (Piedmont) in containers holding more than 10 litres' ||
            '22042932',
        22042938: '22042938 - White wine with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, produced in the Community in a region other than Bordeaux, Bourgogne (Burgundy), Beaujola...' ||
            '22042938',
        22042978: '22042978 - Wine, other than white, with a protected designation of origin (PDO) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, produced in the Community in a region other than Bordeaux, Bourgogne (Burgun...' ||
            '22042978',
        22042979: '22042979 - White wine, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres' ||
            '22042979',
        22042980: '22042980 - Wine, other than white, produced in the Community, with a protected geographical indication (PGI) of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres' ||
            '22042980',
        22042981: '22042981 - White varietal wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, other than wine with a protected designation of origin (PDO) or a protected geographical indicati...' ||
            '22042981',
        22042982: '22042982 - Varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres, other than wine with a protected designation of origin (PDO) or a protected geographi...' ||
            '22042982',
        22042983: '22042983 - Non varietal white wine, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres' ||
            '22042983',
        22042984: '22042984 - Non varietal wine, other than white, produced in the Community, of an actual alcoholic strength by volume not exceeding 15% vol. in containers holding more than 10 litres' ||
            '22042984',
        22042985: '22042985 - Madeira and Setubal muscatel wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042985',
        22042986: '22042986 - Sherry wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042986',
        22042988: '22042988 - Samos and Muscat de Lemnos wine of an actual alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres with a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042988',
        22042990: '22042990 - Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, with a protected designation of origin (PDO) or a protected geographical indication (PGI) other than Madeira and...' ||
            '22042990',
        22042991: '22042991 - Wine of an alcoholic strength by volume exceeding 15% vol. in containers holding more than 10 litres, produced in the Community, without a protected designation of origin (PDO) or a protected geographical indication (PGI)' ||
            '22042991',
        22042993: '22042993 - White wine with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres' ||
            '22042993',
        22042994: '22042994 - Wine, other than white, with a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres' ||
            '22042994',
        22042995: '22042995 - Varietal white wine without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres' ||
            '22042995',
        22042996: '22042996 - Varietal wine, other than white, without a protected designation of origin (PDO) or a protected geographical indication (PGI), not produced in the Community, in containers holding more than 10 litres' ||
            '22042996',
        22042997: '22042997 - Non-varietal white wine, not produced in the Community, in containers holding more than 10 litres' ||
            '22042997',
        22042998: '22042998 - Non-varietal wine, other than white, not produced in the Community, in containers holding more than 10 litres' ||
            '22042998',
        22043010: '22043010 - Grape must in fermentation or with fermentation arrested otherwise than by the addition of alcohol' ||
            '22043010',
        22043096: '22043096 - Concentrated grape must of a density exceeding 1.33 g/cm3 at 20° C and of an actual strength exceeding 1% vol.' ||
            '22043096',
        22043098: '22043098 - Not concentrated grape must of a density exceeding 1.33 g/cm3 at 20° C and of an actual strength exceeding 1% vol.' ||
            '22043098',
        22051010: '22051010 - Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding 2 litres or less' ||
            '22051010',
        22051090: '22051090 - Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding 2 litres or less' ||
            '22051090',
        22059010: '22059010 - Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength of 18% vol. or less in containers holding more than 2 litres' ||
            '22059010',
        22059090: '22059090 - Vermouth and other wine of fresh grapes flavoured with plants or aromatic substances of an actual alcoholic strength exceeding 18% vol. in containers holding more than 2 litres' ||
            '22059090',
        22060010: 'Piquette' || '22060010',
        22060031: '22060031 - Sparkling cider and perry' || '22060031',
        22060039: '22060039 - Other sparkling fermented beverages' || '22060039',
        22060051: '22060051 - Still cider and perry in containers holding 2 litres or less' ||
            '22060051',
        22060059: '22060059 - Other still fermented beverages in containers holding 2 litres or less' ||
            '22060059',
        22060081: '22060081 - Still cider and perry in containers holding more than 2 litres' ||
            '22060081',
        22060089: '22060089 - Other still fermented beverages in containers holding more than 2 litres' ||
            '22060089',
        22071000: '22071000 - Undenatured ethyl alcohol of an alcoholic strength by volume of 80% vol. or higher' ||
            '22071000',
        22072000: '22072000 - Ethyl alcohol and other spirits, denatured, of any strength' ||
            '22072000',
        22082012: '22082012 - Cognac obtained by distilling grape wine in containers holding 2 litres or less' ||
            '22082012',
        22082014: '22082014 - Armagnac obtained by distilling grape wine in containers holding 2 litres or less' ||
            '22082014',
        22082016: '22082016 - Brandy de Jerez obtained by distilling grape wine in containers holding 2 litres or less' ||
            '22082016',
        22082018: '22082018 - Brandy or Weinbrand obtained by distilling grape wine in containers holding 2 litres or less other than Brandy de Jerez' ||
            '22082018',
        22082019: '22082019 - Spirits obtained by distilling grape wine in containers holding 2 litres or less other than Cognac, Armagnac and Brandy or Weinbrand' ||
            '22082019',
        22082026: '22082026 - Grappa obtained by distilling grape marc in containers holding 2 litres or less' ||
            '22082026',
        22082028: '22082028 - Spirits obtained by distilling grape marc in containers holding 2 litres or less other than Grappa' ||
            '22082028',
        22082062: '22082062 - Cognac obtained by distilling grape wine in containers holding more than 2 litres' ||
            '22082062',
        22082066: '22082066 - Brandy or Weinbrand obtained by distilling grape wine in containers holding more than 2 litres' ||
            '22082066',
        22082069: '22082069 - Spirits obtained by distilling grape wine in contains holding more than 2 litres other than Cognac or Brandy or Weinbrand' ||
            '22082069',
        22082086: '22082086 - Grappa obtained by distilling grape marc in contains holding more than 2 litres' ||
            '22082086',
        22082088: '22082088 - Spirits obtained by distilling grape marc in contains holding more than 2 litres other than Grappa' ||
            '22082088',
        22083011: '22083011 - Bourbon whiskey, in containers holding 2 litres or less' ||
            '22083011',
        22083019: '22083019 - Bourbon whiskey, in containers holding more than 2 litres' ||
            '22083019',
        22083030: '22083030 - Scotch whisky, single malt' || '22083030',
        22083041: '22083041 - Scotch whisky, blended malt whisky, in containers holding 2 litres or less' ||
            '22083041',
        22083049: '22083049 - Scotch whisky, blended malt whisky, in containers holding more than 2 litres' ||
            '22083049',
        22083061: '22083061 - Scotch whisky, single grain and blended grain whisky, in containers holding 2 litres or less' ||
            '22083061',
        22083069: '22083069 - Scotch whisky, single grain and blended grain whisky, in containers holding more than 2 litres' ||
            '22083069',
        22083071: '22083071 - Other Scotch blended whisky, in containers holding 2 litres or less' ||
            '22083071',
        22083079: '22083079 - Other Scotch blended whisky, in containers holding more than 2 litres' ||
            '22083079',
        22083082: '22083082 - Whiskey, in containers holding 2 litres or less' ||
            '22083082',
        22083088: '22083088 - Whiskey, in containers holding more than 2 litres' ||
            '22083088',
        22084011: '22084011 - Rum with a content of volatile substances other than ethyl and methyl alcohol equal to or exceeding 225 grams per hectolitre of pure alcohol in containers holding 2 litres or less' ||
            '22084011',
        22084031: '22084031 - Tafia of a value exceeding €7.9 per litre of pure alcohol in containers holding 2 litres or less' ||
            '22084031',
        22084039: '22084039 - Other tafia in containers holding 2 litres or less' ||
            '22084039',
        22084051: '22084051 - Rum with a content of volatile substances other than ethyl and methyl alcohol equal to or exceeding 225 grams per hectolitre of pure alcohol in containers holding more than 2 litres' ||
            '22084051',
        22084091: '22084091 - Tafia of a value exceeding €2 per litre of pure alcohol in containers holding more than 2 litres' ||
            '22084091',
        22084099: '22084099 - Other tafia in containers holding more than 2 litres' ||
            '22084099',
        22085011: '22085011 - Gin, in containers holding 2 litres or less' || '22085011',
        22085019: '22085019 - Gin, in containers holding more than 2 litres' || '22085019',
        22085091: '22085091 - Geneva, in containers holding 2 litres or less' || '22085091',
        22085099: '22085099 - Geneva, in containers holding more than 2 litres' ||
            '22085099',
        22086011: '22086011 - Vodka of an alcoholic strength by volume of 45.4% vol. or less, in containers holding 2 litres or less' ||
            '22086011',
        22086019: '22086019 - Vodka of an alcoholic strength by volume of 45.4% vol. or less, in containers holding more than 2 litres' ||
            '22086019',
        22086091: '22086091 - Vodka of an alcoholic strength by volume of more than 45.4% vol., in containers holding 2 litres or less' ||
            '22086091',
        22086099: '22086099 - Vodka of an alcoholic strength by volume of more than 45.4% vol., in containers more than 2 litres' ||
            '22086099',
        22087010: '22087010 - Liqueurs and cordials, in containers holding 2 litres or less' ||
            '22087010',
        22087090: '22087090 - Liqueurs and cordials, in containers holding more than 2 litres' ||
            '22087090',
        22089011: '22089011 - Arrack, in containers holding 2 litres or less' || '22089011',
        22089019: '22089019 - Arrack, in containers holding more than 2 litres' ||
            '22089019',
        22089033: '22089033 - Plum, pear or cherry spirit in containers holding 2 litres or less' ||
            '22089033',
        22089038: '22089038 - Plum, pear or cherry spirit in containers holding more than 2 litres' ||
            '22089038',
        22089041: '22089041 - Ouzo, in containers holding 2 litres or less' || '22089041',
        22089045: '22089045 - Calvados, in containers holding 2 litres or less' ||
            '22089045',
        22089048: '22089048 - Spirit (excluding liqueurs) distilled from fruit, in containers holding 2 litres or less' ||
            '22089048',
        22089054: '22089054 - Tequila, in containers holding 2 litres or less' ||
            '22089054',
        22089056: '22089056 - Spirit (excluding liqueurs), in containers holding 2 litres or less' ||
            '22089056',
        22089069: '22089069 - Spirituous beverages, in containers holding 2 litres or less' ||
            '22089069',
        22089071: '22089071 - Spirit (excluding liqueurs) distilled from fruit, in containers holding more than 2 litres' ||
            '22089071',
        22089075: '22089075 - Tequila, in containers holding more than 2 litres' ||
            '22089075',
        22089077: '22089077 - Spirit (excluding liqueurs), in containers holding more than 2 litres' ||
            '22089077',
        22089078: '22089078 - Spirituous beverages, in containers holding more than 2 litres' ||
            '22089078',
        22089091: '22089091 - Undenatured ethyl alcohol of an alcoholic strength by volume of less than 80% vol., in containers holding 2 litres or less' ||
            '22089091',
        22089099: '22089099 - Undenatured ethyl alcohol of an alcoholic strength by volume of less than 80% vol., in containers holding more than 2 litres' ||
            '22089099',
        24021000: '24021000 - Cigars, cheroots and cigarillos containing tobacco' ||
            '24021000',
        24022010: '24022010 - Cigarettes containing tobacco / containing cloves' ||
            '24022010',
        24022090: '24022090 - Cigarettes containing tobacco / other' || '24022090',
        24029000: '24029000 - Cigars, cheroots, cigarillos and cigarettes not containing tobacco' ||
            '24029000',
        24031100: '24031100 - Water-pipe tobacco specified in subheading note 1 to chapter 24 of the CN' ||
            '24031100',
        24031910: '24031910 - Smoking tobacco in immediate packing of a net content not exceeding 500 g' ||
            '24031910',
        24031990: '24031990 - Smoking tobacco, other' || '24031990',
        24039100: '24039100 - Homogenised&quot; or &quot;reconstituted&quot; tobacco' ||
            '24039100',
        24039990: '24039990 - Other manufactured tobacco and tobacco substitutes' ||
            '24039990',
        27071000: '27071000 - Benzol (benzene)' || '27071000',
        27072000: '27072000 - Toluol (toluene)' || '27072000',
        27073000: '27073000 - Xylol (xylenes)' || '27073000',
        27075000: '27075000 - Other aromatic hydrocarbon mixtures of which 65 % or more by volume (including losses) distils at 250 °C by the ISO 3405 method (equivalent to the ASTM D 86 method)' ||
            '27075000',
        27101211: '27101211 - Lights oil for undergoing a specific process' || '27101211',
        27101215: '27101215 - Lights oil for undergoing chemical transformations' ||
            '27101215',
        27101221: '27101221 - White spirit' || '27101221',
        27101225: '27101225 - Light oil for other purposes' || '27101225',
        27101231: '27101231 - Aviation spirit' || '27101231',
        27101241: '27101241 - Light oil with a lead content not exceeding 0.013 g per litre with an octane number of less than 95' ||
            '27101241',
        27101245: '27101245 - Light oil with a lead content not exceeding 0.013 g per litre with an octane number of 95 or more but less than 98' ||
            '27101245',
        27101249: '27101249 - Light oil with a lead content not exceeding 0.013 g per litre with an octane number of less than 98 or more' ||
            '27101249',
        27101250: '27101250 - Light oil with a lead content exceeding 0.013 g per litre' ||
            '27101250',
        27101270: '27101270 - Spirit type jet fuel' || '27101270',
        27101290: '27101290 - Other light oil' || '27101290',
        27101911: '27101911 - Medium oil for undergoing a specific process' || '27101911',
        27101915: '27101915 - Medium oil for undergoing chemical transformation' ||
            '27101915',
        27101921: '27101921 - Jet fuel kerosene' || '27101921',
        27101925: '27101925 - Other kerosene' || '27101925',
        27101929: '27101929 - Medium oils for other purposes' || '27101929',
        27101931: '27101931 - Heavy gas oil for undergoing a specific process' ||
            '27101931',
        27101935: '27101935 - Heavy gas oil for undergoing chemical transformation' ||
            '27101935',
        27101943: '27101943 - Heavy gas oil with a sulphur content not exceeding 0.001% by weight, not containing biodiesel' ||
            '27101943',
        27101946: '27101946 - Heavy gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.002%, not containing biodiesel' ||
            '27101946',
        27101947: '27101947 - Heavy gas oil with a sulphur content exceeding 0.002% by weight but not exceeding 0.1%, not containing biodiesel' ||
            '27101947',
        27101948: '27101948 - Heavy gas oil with a sulphur content exceeding 0.1% by weight, not containing biodiesel' ||
            '27101948',
        27101951: '27101951 - Heavy fuel oil for undergoing a specific process' ||
            '27101951',
        27101955: '27101955 - Heavy fuel oil for undergoing chemical transformation' ||
            '27101955',
        27101962: '27101962 - Heavy fuel oil with a sulphur content not exceeding 0.1% by weight, not containing biodiesel' ||
            '27101962',
        27101966: '27101966 - Heavy fuel oil with a sulphur content exceeding 0.1% by weight but not exceeding 0.5%, not containing biodiesel' ||
            '27101966',
        27101967: '27101967 - Heavy fuel oil with a sulphur content exceeding 0.5% by weight, not containing biodiesel' ||
            '27101967',
        27102011: '27102011 - Gas oil with a sulphur content not exceeding 0.001% by weight, containing biodiesel' ||
            '27102011',
        27102016: '27102016 - Gas oil with a sulphur content exceeding 0.001% by weight but not exceeding 0.1%, containing biodiesel' ||
            '27102016',
        27102019: '27102019 - Gas oil with a sulphur content exceeding 0.1% by weight, containing biodiesel' ||
            '27102019',
        27102032: '27102032 - Fuel oil with a sulphur content not exceeding 0.5% by weight, containing biodiesel' ||
            '27102032',
        27102038: '27102038 - Fuel oil with a sulphur content exceeding 0.5% by weight, containing biodiesel' ||
            '27102038',
        27102090: '27102090 - Oljor erhållna ur petroleum eller ur bituminösa mineral (andra än råolja) och produkter, inte nämnda eller inbegripna någon annanstans, innehållande som karaktärsgivande beståndsdel minst 70 viktprocent oljor erhållna ur petroleum eller ur bituminösa mi...' ||
            '27102090',
        27111211: '27111211 - Liquefied Propane of a purity not less than 99 % for use as a power or heating fuel' ||
            '27111211',
        27111219: '27111219 - Liquefied Propane of a purity not less than 99 % for other purposes' ||
            '27111219',
        27111291: '27111291 - Liquefied Propane of a purity less than 99 % for undergoing a specific process' ||
            '27111291',
        27111293: '27111293 - Liquefied Propane of a purity less than 99 % for undergoing a chemical transformation' ||
            '27111293',
        27111294: '27111294 - Liquefied Propane of a purity exceeding 90% but less than 99%' ||
            '27111294',
        27111297: '27111297 - Liquefied propane of a purity not exceeding 90%' ||
            '27111297',
        27111310: '27111310 - Liquefied Butanes for undergoing a specific process' ||
            '27111310',
        27111330: '27111330 - Liquefied Butanes for undergoing a chemical transformation' ||
            '27111330',
        27111391: '27111391 - Liquefied Butanes of a purity exceeding 90 % but of less than 95 %' ||
            '27111391',
        27111397: '27111397 - Butanes with a purity not exceeding 90% or at or above 95%, which are not intended for undergoing a specific process' ||
            '27111397',
        27111400: '27111400 - Ethylene, propylene, butylenes and butadiene liquefied' ||
            '27111400',
        27111900: '27111900 - Petroleum gases etc., liquefied' || '27111900',
        29011000: '29011000 - Acyclic hydrocarbons saturated' || '29011000',
        29022000: '29022000 - Benzene' || '29022000',
        29023000: '29023000 - Toluene' || '29023000',
        29024100: '29024100 - o-Xylene' || '29024100',
        29024200: '29024200 - m-Xylene' || '29024200',
        29024300: '29024300 - p-Xylene' || '29024300',
        29024400: '29024400 - Mixed xylene isomers' || '29024400',
        29051100: '29051100 - Methanol (methyl alcohol)' || '29051100',
        38111110: '38111110 - Anti-knock preparations based on tetraethyl-lead' ||
            '38111110',
        38111190: '38111190 - Anti-knock preparations based on lead compounds other than tetraethyl-lead' ||
            '38111190',
        38111900: '38111900 - Anti-knock preparations other than based on lead compounds' ||
            '38111900',
        38119000: '38119000 - Oxidation inhibitors, gum inhibitors, viscosity improvers, anti-corrosive preparations and other prepared additives, for mineral oils (including gasoline) or for other liquids used for the same purposes as mineral oils other than anti-knock preparation...' ||
            '38119000',
        38248900: '38248900 - Goods specified in subheading note 3 of chapter 38, containing short-chain chlorinated paraffins' ||
            '38248900',
        38249200: '38249200 - Polyglycol esters of methylphosphonic acid other than goods specified in subheading note 3 of chapter 38' ||
            '38249200',
        38249986: '38249986 - Mixtures consisting mainly of dimethyl methylphosphonate, oxirane and diphosphorus pentaoxide' ||
            '38249986',
        38249992: '38249992 - Chemical products or preparations, predominantly composed of organic compounds, not elsewhere specified or included in the form of a liquid at 20 °C' ||
            '38249992',
        38249993: '38249993 - Chemical products or preparations, predominantly composed of organic compounds, not elsewhere specified or included other than in the form of a liquid at 20 °C' ||
            '38249993',
        38249996: '38249996 - Chemical products and preparations of the chemical or allied industries (including those consisting of mixtures of natural products), not elsewhere specified or included' ||
            '38249996',
        38260010: '38260010 - Fatty-acid mono-alkyl esters, containing by volume 96,5 % or more of esters (FAMAE)' ||
            '38260010',
        38260090: '38260090 - Fatty-acid mono-alkyl esters and mixtures thereof, containing by volume less than 96,5 % of esters (FAMAE) and not containing or containing less than 70 % by weight of petroleum oils or oils obtained from bituminous minerals' ||
            '38260090',
    },
    exciseProductCode: 'Produktkod i EMCS' || 'exciseProductCode',
    exciseProductCodes: {
        B000: 'Öl enligt definitionen i artikel 2 i direktiv 92/83/EEG.' || 'B000',
        W200: 'Icke mousserande vin och icke mousserande jästa drycker andra än vin eller öl i enlighet med artiklarna 8.1 och 12.1 i direktiv 92/83/EEG.' ||
            'W200',
        W300: 'Mousserande vin och mousserande jästa drycker andra än vin eller öl i enlighet med artiklarna 8.2 och 12.2 i direktiv 92/83/EEG.' ||
            'W300',
        I000: 'Mellanprodukter enligt definitionen i artikel 17 i direktiv 92/83/EEG.' ||
            'I000',
        S200: 'Alkoholhaltiga drycker enligt definitionen i artikel 20 första, andra och tredje strecksatsen i direktiv 92/83/EEG.' ||
            'S200',
        S300: 'Etylalkohol, enligt definitionen i artikel 20 första strecksatsen i direktiv 92/83/EEG, enligt KN-nummer 2207 och 2208, andra än spritdrycker (S200).' ||
            'S300',
        S400: 'Delvis denaturerad alkohol, enligt artikel 20 i direktiv 92/83/EEG, dvs. alkohol som har denaturerats men som ännu inte uppfyller de villkor som krävs för att omfattas av undantaget enligt artikel 27.1 a eller 27.1 b i det direktivet, andra än spritdrycker (S200).' ||
            'S400',
        S500: 'Produkter som innehåller etylalkohol enligt definitionen i artikel 20 första strecksatsen i direktiv 92/83/EEG, enligt andra KN-nummer än 2207 och 2208.' ||
            'S500',
        S600: 'Fullständigt denaturerad alkohol, enligt artikel 20 i direktiv 92/83/EEG, det vill säga alkohol som har denaturerats och som uppfyller de villkor som krävs för att omfattas av undantaget enligt artikel 27.1 a i det direktivet.' ||
            'S600',
    },
    colliPerPallet: 'Antal kartonger / pall' || 'colliPerPallet',
    externalReferenceUrl: 'Länk till extern källa' || 'externalReferenceUrl',
    hasLongerDeliveryTime: 'Längre leveranstid - visa som beställningsvara för kund' ||
        'hasLongerDeliveryTime',
    numberOfExtraDeliveryDays: 'Antal extra leveransdagar' || 'numberOfExtraDeliveryDays',
    hasDailyPrice: 'Dagspris' || 'hasDailyPrice',
    HSCode: 'Tullstatistiskt HS-nummer' || 'HSCode',
    labels: 'Etiketter' || 'labels',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    currentNewPeriodStarted: 'Är detta en nyhet just nu?' || 'currentNewPeriodStarted',
    popularity: 'Populäritet' || 'popularity',
    myCustomerPopularity: 'Populäritet hos mig' || 'myCustomerPopularity',
    isOrderable: 'Lagerställe' || 'isOrderable',
    blockedQuantity: 'Blockat antal (st)' || 'blockedQuantity',
    hasBatchWithExpiredDate: 'Finns utgångna artiklar på lager' || 'hasBatchWithExpiredDate',
    hasBatchWithShortDate: 'Har artikel med kort datum' || 'hasBatchWithShortDate',
    responsibleForDelivery: 'Ansvarig för leverans' || 'responsibleForDelivery',
    articleBatches: {
        id: 'id' || 'id',
        batchNumber: 'Batchnummer' || 'batchNumber',
        expiryDate: 'Utgår' || 'expiryDate',
        quantityInStock: 'Lagersaldo (st)' || 'quantityInStock',
        blockedQuantity: 'Blockerat saldo' || 'blockedQuantity',
        orderFullfillmentCenter: 'Lagerställe' || 'orderFullfillmentCenter',
        isAlwaysOrderable: 'Alltid beställningsbar' || 'isAlwaysOrderable',
        isBlocked: 'Blockad' || 'isBlocked',
        blockReason: 'Anledning till blockering' || 'blockReason',
    },
    articleLinks: {
        id: 'id' || 'id',
        name: 'Namn' || 'name',
        href: 'Länk' || 'href',
    },
    stockKeepingUnits: {
        id: 'id' || 'id',
        isMainUnit: 'Är huvudenhet' || 'isMainUnit',
        name: 'Enhet' || 'name',
        names: {
            lav: 'LAV' || 'lav',
            bag_in_box: 'BIB' || 'bag_in_box',
            PET: 'PET' || 'PET',
            pallet: 'pall' || 'pallet',
            package: 'kolli' || 'package',
            pcs: 'st' || 'pcs',
            kg: 'kg' || 'kg',
            hg: 'hg' || 'hg',
            g: 'g' || 'g',
            liter: 'liter' || 'liter',
            dl: 'dl' || 'dl',
            cl: 'cl' || 'cl',
            ml: 'ml' || 'ml',
            case: 'ask' || 'case',
            crate: 'back' || 'crate',
            bale: 'bal' || 'bale',
            big_box: 'bbox' || 'big_box',
            piece: 'bit' || 'piece',
            block: 'block' || 'block',
            book: 'bok' || 'book',
            tray: 'bricka' || 'tray',
            bouquet: 'bukett' || 'bouquet',
            bundle: 'bunt' || 'bundle',
            can: 'burk' || 'can',
            tub: 'bytta' || 'tub',
            mug: 'bägare' || 'mug',
            big_can: 'dunk' || 'big_can',
            disposable_glass: 'eng.glas' || 'disposable_glass',
            barrel: 'fat' || 'barrel',
            package4: 'flak' || 'package4',
            bottle: 'flaska' || 'bottle',
            braid: 'fläta' || 'braid',
            package2: 'förp' || 'package2',
            glass: 'glas' || 'glass',
            bucket: 'hink' || 'bucket',
            keg: 'kagge' || 'keg',
            capsules: 'kapslar' || 'capsules',
            sv_karta: 'karta' || 'sv_karta',
            carton: 'kartong' || 'carton',
            cassette: 'kassett' || 'cassette',
            bunch: 'klase' || 'bunch',
            bundle2: 'knippe' || 'bundle2',
            basket: 'korg' || 'basket',
            pot: 'kruka' || 'pot',
            quarter_pallet: 'kvartspall' || 'quarter_pallet',
            box: 'låda' || 'box',
            bulk: 'lösvikt' || 'bulk',
            m: 'm' || 'm',
            m2: 'm2' || 'm2',
            net: 'nät' || 'net',
            package3: 'paket' || 'package3',
            package5: 'platta' || 'package5',
            bag: 'påse' || 'bag',
            recycle_glass: 'ret.glas' || 'recycle_glass',
            roll: 'rulle' || 'roll',
            side: 'sida' || 'side',
            sack: 'säck' || 'sack',
            tetra: 'tetra' || 'tetra',
            trough: 'tråg' || 'trough',
            tube: 'tub' || 'tube',
            wagon: 'vagn' || 'wagon',
            unknown: 'Okänd' || 'unknown',
        },
        supplierName: 'Leverantörens enhet' || 'supplierName',
        GTIN: 'GTIN' || 'GTIN',
        quantityOfMainUnitPerUnit: 'Huvudenheter per enhet' || 'quantityOfMainUnitPerUnit',
        minOrderQuantity: 'Minsta kvantitet' || 'minOrderQuantity',
        stepOrderIncrement: 'Kvantitetssteg' || 'stepOrderIncrement',
        grossWeight: 'Bruttovikt' || 'grossWeight',
    },
};
